import React from "react";
import Icon from "@ant-design/icons";

export const NotificationSvg = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 15.5457H19.75"
      stroke="#6D8991"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M2.07703 15.5457C2.07703 15.5457 2.32501 15.0507 2.62701 14.4437C2.93001 13.8387 3.47799 11.5687 3.84399 9.39874L4.33502 6.48969C4.70102 4.31968 6.80098 2.54572 9.00098 2.54572H10.75C12.95 2.54572 15.05 4.31968 15.416 6.48969L15.907 9.39874C16.273 11.5687 16.821 13.8377 17.124 14.4437C17.427 15.0497 17.674 15.5457 17.674 15.5457"
      stroke="#6D8991"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M12.069 17.5457C12.069 18.6697 10.812 19.1917 9.875 19.1917C8.938 19.1917 7.68103 18.6707 7.68103 17.5457"
      stroke="#6D8991"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M9.875 2.54572V-0.333313"
      stroke="#6D8991"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export const UserSvg = () => (
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 5C14 7.209 12.211 9 10 9C7.791 9 6 7.209 6 5C6 2.791 7.791 1 10 1C12.211 1 14 2.791 14 5Z"
      stroke="#6D8991"
      strokeWidth="2"
    />
    <path
      d="M2 18C2.091 17 2.272 16.476 2.51 15.958C2.857 15.206 3.364 14.604 4.043 14.17C5.455 13.268 7.506 13.001 9.999 13.001C12.492 13.001 14.544 13.245 15.957 14.149C16.635 14.583 17.145 15.209 17.488 15.961C17.728 16.482 17.91 17 18 18H2Z"
      stroke="#6D8991"
      strokeWidth="2"
    />
  </svg>
);
export const ImportSettingsSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM13.51 10.16C13.92 9.43 14.69 9 15.14 8.36C15.62 7.68 15.35 6.42 14 6.42C13.12 6.42 12.68 7.09 12.5 7.65L11.13 7.08C11.51 5.96 12.52 5 13.99 5C15.22 5 16.07 5.56 16.5 6.26C16.87 6.86 17.08 7.99 16.51 8.83C15.88 9.76 15.28 10.04 14.95 10.64C14.82 10.88 14.77 11.04 14.77 11.82H13.25C13.26 11.41 13.19 10.74 13.51 10.16ZM12.95 13.95C12.95 13.36 13.42 12.91 14 12.91C14.59 12.91 15.04 13.36 15.04 13.95C15.04 14.53 14.6 15 14 15C13.42 15 12.95 14.53 12.95 13.95Z"
      fill="#6D8991"
    />
  </svg>
);

export const ExitSvg = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.09 12.59L8.5 14L13.5 9L8.5 4L7.09 5.41L9.67 8H0V10H9.67L7.09 12.59ZM16 0H2C0.89 0 0 0.9 0 2V6H2V2H16V16H2V12H0V16C0 17.1 0.89 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0Z"
      fill="#6D8991"
    />
  </svg>
);

export const AddSvg_ = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM11 18V13H6V11H11V6H13V11H18V13H13V18H11Z"
    />
  </svg>
);

const WrapSvg = () => (
  <svg
    width="12"
    height="20"
    viewBox="0 0 12 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.872871 11.2559C0.412409 10.8572 0.412409 10.1428 0.872871 9.74407L5.84535 5.43778C6.49299 4.87691 7.5 5.33696 7.5 6.19371L7.5 14.8063C7.5 15.663 6.49299 16.1231 5.84535 15.5622L0.872871 11.2559Z"
      fill="#2d3a3e"
      fillOpacity="0.9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 0C11.5523 0 12 0.447715 12 1V19C12 19.5523 11.5523 20 11 20C10.4477 20 10 19.5523 10 19V1C10 0.447715 10.4477 0 11 0Z"
      fill="#2d3a3e"
      fillOpacity="0.9"
    />
  </svg>
);
export const ArrowSvg = () => (
  <svg
    width="16"
    height="10"
    viewBox="0 0 16 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15 9L8 2L1 9" stroke="#6D8991" strokeWidth="2" />
  </svg>
);
export const ArrowRightSvg = () => (
  <svg
    width="18"
    height="12"
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M-0.00224678 6.97958L14.1677 7.01173L10.5796 10.5936L11.9864 12.0068L18 6.02042L12.0136 0.00682249L10.6004 1.41362L14.1723 5.01173L0.00229107 4.97958L-0.00224678 6.97958Z"
      fill="#6D8991"
    />
  </svg>
);

export const UploadSvg = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12ZM12 2L17.55 7.46L16.13 8.87L13 5.75V15H11V5.75L7.88 8.87L6.46 7.45L12 2Z" />
  </svg>
);

export const DownLoadSvg = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12ZM12 15L17.55 9.54L16.13 8.13L13 11.25V2H11V11.25L7.88 8.13L6.46 9.55L12 15Z" />
  </svg>
);

export const DownloadPdfSvg = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M 11 2 L 11 7.0878906 L 7.8808594 3.96875 L 6.4609375 5.3886719 L 12 10.837891 L 17.550781 5.3789062 L 16.130859 3.96875 L 13 7.0878906 L 13 2 L 11 2 z M 1.5800781 12.003906 L 1.5800781 19.275391 L 3.4550781 19.275391 L 3.4550781 16.90625 L 4.6210938 16.90625 C 5.1516927 16.90625 5.594401 16.833984 5.9492188 16.6875 C 6.3072917 16.541016 6.6321615 16.323568 6.921875 16.037109 C 7.1334635 15.825521 7.296224 15.565104 7.4101562 15.255859 C 7.5240885 14.943359 7.5820312 14.624349 7.5820312 14.298828 C 7.5820312 13.878906 7.5039062 13.520182 7.3476562 13.220703 C 7.1946615 12.921224 6.9707031 12.674479 6.6777344 12.482422 C 6.4335937 12.322917 6.1510417 12.205078 5.8320312 12.126953 C 5.516276 12.045573 5.1282552 12.003906 4.6660156 12.003906 L 1.5800781 12.003906 z M 8.9101562 12.003906 L 8.9101562 19.275391 L 11.472656 19.275391 C 12.052083 19.275391 12.553385 19.233073 12.976562 19.148438 C 13.39974 19.063802 13.789714 18.914062 14.144531 18.699219 C 14.616536 18.41276 15.007161 18.002604 15.316406 17.46875 C 15.625651 16.931641 15.779297 16.323568 15.779297 15.646484 C 15.779297 14.943359 15.633464 14.333984 15.34375 13.816406 C 15.057292 13.295573 14.665365 12.882161 14.164062 12.576172 C 13.871094 12.39388 13.507812 12.253906 13.078125 12.15625 C 12.648438 12.055339 12.139323 12.003906 11.546875 12.003906 L 8.9101562 12.003906 z M 17.210938 12.003906 L 17.210938 19.275391 L 19.074219 19.275391 L 19.074219 16.169922 L 22.175781 16.169922 L 22.175781 14.763672 L 19.074219 14.763672 L 19.074219 13.410156 L 22.419922 13.410156 L 22.419922 12.003906 L 17.210938 12.003906 z M 3.4550781 13.361328 L 3.7773438 13.361328 C 4.0865885 13.361328 4.3339844 13.367188 4.5195312 13.376953 C 4.7050781 13.383464 4.8945312 13.425781 5.0898438 13.503906 C 5.2363281 13.5625 5.3658854 13.666667 5.4765625 13.816406 C 5.5872396 13.962891 5.6425781 14.138672 5.6425781 14.34375 C 5.6425781 14.552083 5.6139323 14.728516 5.5585938 14.875 C 5.5065104 15.018229 5.421224 15.141927 5.3007812 15.246094 C 5.1608073 15.363281 4.9856771 15.441406 4.7773438 15.480469 C 4.5722656 15.519531 4.3111979 15.539062 3.9921875 15.539062 L 3.4550781 15.539062 L 3.4550781 13.361328 z M 10.785156 13.361328 L 11.257812 13.361328 C 11.661458 13.361328 11.961589 13.380208 12.160156 13.416016 C 12.361979 13.448568 12.559896 13.511068 12.751953 13.605469 C 13.129557 13.797526 13.405599 14.064453 13.578125 14.40625 C 13.753906 14.744792 13.839844 15.154297 13.839844 15.632812 C 13.839844 16.114583 13.761068 16.51888 13.601562 16.847656 C 13.442057 17.173177 13.191406 17.433594 12.849609 17.628906 C 12.651042 17.736328 12.446615 17.811198 12.238281 17.853516 C 12.029948 17.892578 11.703776 17.912109 11.257812 17.912109 L 10.785156 17.912109 L 10.785156 13.361328 z " />
  </svg>
);

export const TeploSvg = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="28" height="28" rx="4" className="disable" fill="#FFB405" />
    <g clipPath="url(#clip0_181_3216)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.575 4.04166C22.1 4.04166 22.5417 4.50832 22.6 5.11666L23.9917 23.6083C24 23.7167 23.9583 23.825 23.8917 23.9083C23.8167 23.9917 23.725 24.0333 23.625 24.0333H17.5417L18.9583 5.07499C18.9583 4.50832 19.4083 4.04166 19.9833 4.04166H21.575ZM10.8 12.225C10.8 12.1 10.8833 11.9917 11.0083 11.925C11.1417 11.8583 11.2917 11.85 11.425 11.9083L16.7167 14.125L15.725 24.0417H4V11.8667C4 11.7417 4.075 11.6333 4.2 11.5667C4.325 11.5 4.475 11.4917 4.60833 11.5417L10.8 13.9833V12.225ZM8.01667 22.2167C8.33333 22.2167 8.59167 21.9667 8.59167 21.65H8.6V16.225C8.6 15.9167 8.34167 15.6583 8.025 15.6583H6.75833C6.44167 15.6583 6.18333 15.9083 6.18333 16.225V21.65C6.18333 21.9583 6.44167 22.2167 6.75833 22.2167H8.01667ZM13.375 16.2167C13.375 15.9083 13.1167 15.65 12.8 15.65H11.5417C11.225 15.65 10.9667 15.9 10.9667 16.2167V21.6417C10.9667 21.95 11.225 22.2083 11.5417 22.2083H12.8C13.1167 22.2083 13.375 21.9583 13.375 21.6417V16.2167Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_181_3216">
        <rect width="20" height="20" fill="white" transform="translate(4 4)" />
      </clipPath>
    </defs>
  </svg>
);
export const ExportSvg = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 3C4 2.44772 4.44772 2 5 2H15.2667H15.6966L15.9923 2.31196L18.1257 4.56196L19.7257 6.24946L20 6.53879V6.9375V13H18V8H14V4H6V20H11.5333H15.2667V22H11.5333H5C4.44772 22 4 21.5523 4 21V3ZM18 20V15H20V20H21.5L19 22.5L16.5 20H18ZM9.3122 11C9.37449 11 9.43322 11.029 9.47106 11.0785L11 13.0776L12.5289 11.0785C12.5668 11.029 12.6255 11 12.6878 11L13.7976 11C13.8805 11 13.9274 11.095 13.8771 11.1608L11.7055 14L13.8771 16.8392C13.9274 16.905 13.8805 17 13.7976 17L12.6878 17C12.6255 17 12.5667 16.971 12.5289 16.9215L11 14.9225L9.4711 16.9215C9.43326 16.971 9.37453 17 9.31224 17L8.20238 17C8.11954 17 8.07262 16.905 8.12295 16.8392L10.2945 14L8.12295 11.1608C8.07262 11.095 8.11954 11 8.20238 11L9.3122 11Z"
    />
  </svg>
);

export const LightSvg = () => (
  <svg
    width="39"
    height="38"
    viewBox="0 0 39 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="disable"
      d="M0 3C0 1.34315 1.34315 0 3 0H39V38H3C1.34315 38 0 36.6569 0 35V3Z"
      fill="#DAF567"
    />
    <g clipPath="url(#clip0_501_3738)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 26.57V11.43C7 8.95 8.49 7 10.4 7H12.48V10.26H10.57C10.45 10.41 10.26 10.82 10.26 11.43V26.57C10.26 27.18 10.45 27.59 10.57 27.74H12.48V31H10.4C8.49 31 7 29.05 7 26.57ZM25.52 7H27.6C29.51 7 31 8.95 31 11.43V26.57C31 29.05 29.51 31 27.6 31H25.52V27.74H27.43C27.55 27.59 27.74 27.18 27.74 26.57V11.43C27.74 10.82 27.55 10.41 27.43 10.26H25.52V7ZM21.24 24.87H16.76C16.64 24.87 16.53 25.08 16.53 25.33V26.09C16.53 26.35 16.63 26.55 16.76 26.55H21.25C21.37 26.55 21.48 26.34 21.48 26.09V25.33C21.47 25.07 21.37 24.87 21.24 24.87ZM21.79 12.25C22.04 12.4 22.27 12.56 22.5 12.76C23.34 13.48 23.93 14.41 24.18 15.47C24.55 17.02 24.3 18.48 23.4 19.81C23.06 20.32 22.59 20.74 22.1 21.13C22.02 21.2 21.99 21.28 21.99 21.39V21.86V22.43V22.67C21.99 22.88 21.82 23.04 21.61 23.04H16.4C16.19 23.04 16.02 22.87 16.02 22.66V21.68V21.67V21.66V21.64C16.02 21.6276 16.021 21.6153 16.022 21.602C16.0243 21.5724 16.0269 21.5384 16.02 21.49V21.46V21.45C16.02 21.4 16.01 21.36 16 21.32C15.9956 21.3112 15.9932 21.3025 15.991 21.2945C15.9881 21.2844 15.9856 21.2756 15.98 21.27C15.96 21.22 15.92 21.17 15.87 21.12C15.06 20.42 14.32 19.63 13.98 18.62C13.32 16.67 13.65 14.88 14.96 13.31C15.33 12.87 15.76 12.5 16.25 12.2C16.49 12.06 16.74 11.94 17 11.83C17.26 11.72 17.53 11.64 17.81 11.58H17.82C18.03 11.54 18.24 11.5 18.45 11.48C18.52 11.47 18.58 11.47 18.65 11.47C18.6594 11.4693 18.6687 11.4687 18.678 11.468C18.8074 11.4587 18.9287 11.45 19.05 11.45H19.07C19.35 11.45 19.62 11.48 19.89 11.52C19.925 11.525 19.9575 11.5325 19.99 11.54C20.0225 11.5475 20.055 11.555 20.09 11.56C20.35 11.61 20.6 11.68 20.84 11.77C20.85 11.77 20.87 11.77 20.88 11.78C21.13 11.88 21.38 12 21.61 12.14C21.64 12.16 21.67 12.1775 21.7 12.195C21.73 12.2125 21.76 12.23 21.79 12.25ZM21.8 16.79C21.99 16.79 22.16 16.71 22.29 16.59C22.43 16.46 22.52 16.28 22.51 16.07C22.51 14.5 21.22 13.22 19.64 13.22C19.41 13.22 19.22 13.33 19.09 13.49C18.99 13.61 18.92 13.76 18.92 13.93C18.92 14.33 19.25 14.65 19.64 14.65C20.44 14.65 21.08 15.28 21.08 16.07C21.08 16.47 21.41 16.79 21.8 16.79Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_501_3738">
        <rect width="24" height="24" fill="white" transform="translate(7 7)" />
      </clipPath>
    </defs>
  </svg>
);
export const DrainageSvg = () => (
  <svg
    width="39"
    height="38"
    viewBox="0 0 39 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="disable"
      d="M0 3C0 1.34315 1.34315 0 3 0H39V38H3C1.34315 38 0 36.6569 0 35V3Z"
      fill="#9013FE"
    />
    <g clipPath="url(#clip0_501_3736)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0599 14.1H11.6099C11.9299 14.1 12.1899 13.88 12.2699 13.59H18.0499C18.4199 13.59 18.6799 13.84 18.6799 14.2V15.6H24.9499V14.2C24.9499 10.51 21.8699 7.53 18.0499 7.53H12.2699C12.1999 7.22 11.9299 7 11.6099 7H11.0599C10.6899 7 10.3799 7.31 10.3799 7.68V13.42C10.3799 13.79 10.6899 14.1 11.0599 14.1ZM15.88 25.87C15.76 25.42 15.56 24.96 15.32 24.48C14.93 23.72 14.41 22.93 13.9 22.2C12.89 20.75 11.89 19.59 11.89 19.59L11.5 19.14L11.1 19.6C11.1 19.6 10.1 20.76 9.09 22.21C8.84 22.57 8.58 22.95 8.34 23.33C8.22 23.52 8.1 23.71 7.99 23.91C7.95051 23.9818 7.91103 24.0523 7.87201 24.122L7.872 24.122C7.80231 24.2464 7.7341 24.3682 7.67 24.49C7.635 24.56 7.60001 24.6325 7.56501 24.705C7.53001 24.7775 7.495 24.85 7.46 24.92L7.28 25.34C7.11 25.79 7 26.23 7 26.66C7 29.04 9.02 31 11.49 31C13.96 31 15.98 29.04 15.98 26.66V26.66C15.98 26.58 15.98 26.49 15.97 26.4C15.96 26.23 15.92 26.05 15.88 25.87ZM11.49 29.75C9.69 29.75 8.23 28.29 8.23 26.5C8.23 26.05 8.59 25.69 9.04 25.69C9.49 25.69 9.85 26.05 9.85 26.5V26.58C9.89 27.43 10.61 28.12 11.48 28.12C11.5324 28.12 11.5771 28.1276 11.6276 28.1362H11.6276L11.65 28.14C12.02 28.22 12.3 28.54 12.3 28.94C12.31 29.39 11.94 29.75 11.49 29.75ZM29.7701 23.9H30.3201C30.6901 23.9 31.0001 24.21 30.9901 24.58V30.32C30.9901 30.69 30.6801 31 30.3101 31H29.7601C29.4401 31 29.1801 30.78 29.1001 30.49H25.5701C21.7501 30.49 18.6701 27.51 18.6701 23.82V20.1H18.2001C17.7201 20.1 17.3201 19.7 17.3201 19.22V18.47C17.3201 17.99 17.7201 17.59 18.2001 17.59H25.4601C25.9401 17.59 26.3401 17.99 26.3401 18.47V19.22C26.3401 19.7 25.9401 20.1 25.4601 20.1H24.9501V23.81C24.9501 24.12 25.2701 24.42 25.5801 24.42H29.1101C29.1801 24.12 29.4501 23.9 29.7701 23.9Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_501_3736">
        <rect width="24" height="24" fill="white" transform="translate(7 7)" />
      </clipPath>
    </defs>
  </svg>
);
export const WaterSvg = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect className="disable" width="28" height="28" rx="4" fill="#80DEEA" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 6.75C15.3417 6.75 16.6 7.11667 17.6833 7.75833L19.675 5.76667C18.0583 4.65 16.1083 4 14 4C8.475 4 4 8.475 4 14C4 16.1083 4.65 18.0583 5.76667 19.675L7.75833 17.6833C7.11667 16.6 6.75 15.3417 6.75 14C6.75 10 10 6.75 14 6.75ZM22.5417 8.79167L20.5167 10.8167C20.9917 11.775 21.25 12.8583 21.25 14C21.25 18 18 21.25 14 21.25C12.8583 21.25 11.7833 20.9833 10.8167 20.5167L8.79167 22.5417C10.3083 23.4667 12.0917 24 14 24C19.525 24 24 19.525 24 14C24 12.0917 23.4667 10.3083 22.5417 8.79167ZM16.9333 13.775C17 13.9166 17.0667 14.0583 17.1167 14.1916C17.1199 14.1949 17.1219 14.1969 17.1236 14.1991C17.1263 14.2025 17.1283 14.2065 17.1333 14.2166C17.1833 14.3416 17.225 14.475 17.2583 14.6C17.3083 14.8 17.3417 14.9916 17.3417 15.1833C17.3417 16.9583 15.8417 18.4083 14.0083 18.4083C13.6833 18.4083 13.375 18.3583 13.075 18.275C13.0667 18.2708 13.0562 18.2687 13.0458 18.2666C13.0354 18.2646 13.025 18.2625 13.0167 18.2583C12.7 18.1583 12.4083 18.025 12.1417 17.85C11.9667 17.7333 11.8 17.6083 11.65 17.4583C11.575 17.3833 11.5 17.3083 11.4333 17.225C11.3 17.0666 11.175 16.8916 11.075 16.7083C10.8167 16.25 10.6667 15.725 10.6667 15.175C10.6667 15.025 10.6833 14.875 10.7167 14.7083C10.7417 14.6 10.775 14.4833 10.8083 14.375C10.8428 14.2646 10.8887 14.1542 10.9366 14.0391C10.9466 14.0152 10.9566 13.991 10.9667 13.9666C10.9917 13.9 11.025 13.825 11.0583 13.7583C11.075 13.725 11.0938 13.6896 11.1125 13.6541C11.1313 13.6187 11.15 13.5833 11.1667 13.55C11.2417 13.4083 11.3167 13.2666 11.4 13.125C11.4833 12.9833 11.5667 12.8416 11.6583 12.7C11.8417 12.4166 12.025 12.1333 12.2167 11.8666C12.3202 11.7205 12.4236 11.5789 12.5239 11.4417C12.5609 11.3911 12.5974 11.3411 12.6333 11.2916C12.7072 11.1901 12.781 11.0937 12.852 11.001C12.9092 10.9263 12.9646 10.854 13.0167 10.7833C13.0701 10.7192 13.1201 10.6551 13.1667 10.5954C13.1927 10.5619 13.2177 10.5299 13.2417 10.5C13.525 10.15 13.7083 9.93331 13.7083 9.93331L14 9.59998L14.2833 9.94164C14.2833 9.94164 14.3917 10.0666 14.5583 10.275C14.6167 10.3416 14.6833 10.4249 14.75 10.5083L14.75 10.5083C14.7625 10.525 14.7771 10.5416 14.7917 10.5583C14.8062 10.575 14.8208 10.5916 14.8333 10.6083C15.1 10.95 15.4417 11.3916 15.775 11.8833C16.0583 12.2833 16.3417 12.7166 16.5917 13.1416C16.675 13.2833 16.75 13.425 16.825 13.5666C16.8564 13.6169 16.8831 13.6719 16.9086 13.7245C16.9169 13.7416 16.9251 13.7586 16.9333 13.775ZM13.9333 17.4708C13.9562 17.4729 13.9792 17.475 14 17.475C14.3333 17.475 14.6 17.2 14.6 16.875C14.6 16.8333 14.5917 16.7916 14.5833 16.75C14.5333 16.5166 14.35 16.3333 14.1167 16.2833L14.1167 16.2833C14.075 16.275 14.0333 16.2666 13.9917 16.2666C13.3417 16.2666 12.8167 15.7583 12.7833 15.125V15.0666C12.7833 14.7333 12.5167 14.4666 12.1833 14.4666C11.85 14.4666 11.5833 14.7333 11.5833 15.0666C11.5833 16.35 12.5917 17.4 13.8667 17.4666C13.8875 17.4666 13.9104 17.4687 13.9333 17.4708Z"
      fill="white"
    />
  </svg>
);
export const WaterTwoSvg = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="28" height="28" rx="4" className="disable" fill="#64B5F6" />
    <g clipPath="url(#clip0_181_3213)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.40006 5.14166C9.5584 5.14166 9.7084 5.03332 9.79173 4.85832C9.87506 4.68332 9.87506 4.46666 9.79173 4.28332C9.71673 4.10832 9.56673 3.99999 9.40006 3.99999H4.46673C4.3334 3.99166 4.2084 4.05832 4.12507 4.17499C4.0334 4.29999 3.99173 4.45832 4.00007 4.62499C4.00007 4.64999 4.0084 4.67499 4.01673 4.69999C4.06673 4.95832 4.25007 5.14166 4.46673 5.14166H4.91673V16.2083H4.46673C4.21673 16.2083 4.01673 16.4583 4.01673 16.775C4.01673 17.0917 4.21673 17.3417 4.46673 17.3417H9.4084C9.6584 17.3417 9.8584 17.0917 9.8584 16.775C9.8584 16.4583 9.6584 16.2083 9.4084 16.2083H8.9584V5.14166H9.40006ZM15.6084 14.3333C15.6084 15.325 16.4083 16.1333 17.3917 16.1333C14.925 16.1333 12.9333 15.0167 12.9333 12.5333C12.9333 10.7818 13.9073 9.49113 14.7663 8.35281C15.4439 7.45481 16.05 6.65159 16.05 5.79166C16.05 5.67499 16.1 5.55832 16.1834 5.47499C16.2667 5.39166 16.3834 5.34166 16.5 5.34166C16.5917 5.34166 16.6917 5.37499 16.7667 5.43332C17.0167 5.58332 21.8417 8.59166 21.8417 12.5333C21.8417 15.0167 19.85 16.1333 17.3917 16.1333C18.375 16.1333 19.1667 15.325 19.1667 14.3333C19.1667 11.6333 17.8334 10.2833 17.8334 10.2833C17.8334 10.2833 17.8334 13.4333 16.9417 13.4333C16.4917 13.4333 16.05 12.5333 16.05 12.5333C16.05 12.5333 15.6084 13.4333 15.6084 14.3333ZM22.8667 18.5416C22.8667 18.2916 23.1167 18.0916 23.4334 18.0916C23.75 18.0916 24 18.2916 24 18.55V23.5333C24 23.7833 23.75 23.9833 23.4334 23.9833C23.1167 23.9833 22.8667 23.7833 22.8667 23.5333V23.0833H11.9V23.5333C11.9084 23.75 11.7167 23.9333 11.4584 23.9833C11.4417 23.9916 11.4167 24 11.3917 24C11.2334 24.0083 11.0667 23.9666 10.95 23.875C10.8334 23.7916 10.7667 23.6666 10.775 23.5333V18.55C10.775 18.3833 10.8834 18.2333 11.0584 18.15C11.2334 18.0666 11.45 18.0666 11.625 18.15C11.8084 18.2333 11.9084 18.3833 11.9084 18.55V19H22.8667V18.5416ZM9.525 18.5333V23.1C7.025 23.1 5 21.05 5 18.5333H9.525Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_181_3213">
        <rect width="20" height="20" fill="white" transform="translate(4 4)" />
      </clipPath>
    </defs>
  </svg>
);
export const ElectroSvg = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="28" height="28" rx="4" className="disable" fill="#7ED321" />
    <g clipPath="url(#clip0_181_3219)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.575 22.3333H4L13.375 4L16.325 9.775L14.8667 12.9583L13.375 10.0417L8.49167 19.5833H11.8333L10.575 22.3333ZM21.7 20.275L21.6084 20.5083H21.8167H23.4167L22.3084 21.4666L21.2917 22.3333L20.325 23.1666L19.35 24L18.8167 23.1666L18.2834 22.3333L17.1417 20.5333H18.8084L20.125 17.2083L20.3334 16.6833H19.8584H16.775H16.3334L16.5417 16.2333L18.0334 13.1083L20.0417 8.87498H21.025H22.7917L21.95 10.6416L20.0334 14.6666H24L21.7 20.275Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_181_3219">
        <rect width="20" height="20" fill="white" transform="translate(4 4)" />
      </clipPath>
    </defs>
  </svg>
);
export const MapControlSvg = () => (
  <svg
    width="24"
    height="21"
    viewBox="0 0 24 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 0.883453L12.4448 1.10441L22.0448 5.87268L23.8482 6.7684L22.0447 7.66394L12.4447 12.431L12 12.6518L11.5552 12.431L1.95521 7.66394L0.151745 6.7684L1.95511 5.87268L11.5551 1.10441L12 0.883453ZM4.64817 6.76817L12 10.4188L19.3518 6.76817L12 3.11657L4.64817 6.76817ZM2.39488 9.72252L2.43606 9.63966L2.43658 9.63992L12.0001 14.3894L21.5639 9.63977L21.5641 9.63966L21.6053 9.72256L21.6438 9.64467L22.0438 9.84273L23.852 10.738L22.0445 11.6347L21.5107 11.8995L21.5101 11.8998L21.51 11.8996L12.4449 16.4016L12.0001 16.6225L11.5553 16.4016L2.489 11.899L2.48872 11.8996L2.48835 11.8994L1.95512 11.6345L0.149536 10.7374L1.95633 9.84273L2.35633 9.64467L2.39488 9.72252ZM2.43606 13.6102L2.39488 13.6931L2.35633 13.6153L1.95633 13.8133L0.149539 14.708L1.95512 15.605L2.48835 15.87L2.48872 15.8701L2.489 15.8696L11.5553 20.3721L12.0001 20.593L12.4449 20.3721L21.51 15.8702L21.5101 15.8704L21.5107 15.8701L22.0445 15.6053L23.852 14.7086L22.0438 13.8133L21.6438 13.6153L21.6053 13.6931L21.5641 13.6102L21.5639 13.6103L12.0001 18.36L2.43658 13.6105L2.43606 13.6102Z"
      fill="#6D8991"
    />
  </svg>
);

export const SearchSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 10.0004C4 6.68663 6.68467 4 10 4C13.3153 4 16 6.68663 16 10.0004C16 13.3189 13.316 16 10 16C6.68401 16 4 13.3189 4 10.0004ZM10 2C5.57956 2 2 5.5826 2 10.0004C2 14.4243 5.58021 18 10 18C12.1049 18 14.0194 17.189 15.4475 15.8615L20.793 21.207L22.2072 19.7928L16.7357 14.3214C17.536 13.0758 18 11.5931 18 10.0004C18 5.5826 14.4204 2 10 2Z"
      fill="#6D8991"
    />
  </svg>
);
export const FilterSvg = () => (
  <svg
    width="15px"
    height="15px"
    viewBox="0 0 15 15"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="GIS" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Гис-фильтр1"
        transform="translate(-769.000000, -24.000000)"
        fill="#4ba594"
        fillRule="nonzero"
      >
        <g id="Group-14" transform="translate(752.000000, 9.000000)">
          <g id="Group-12" transform="translate(17.000000, 15.000000)">
            <g id="icons8-filter_filled">
              <path
                d="M0.326086957,0 C0.129925435,0 0,0.129925435 0,0.326086957 L0,1.30434783 C0,1.40242859 0.0369394565,1.46356989 0.101902174,1.52853261 L5.31929348,7.07201087 C5.3842562,7.13697359 5.47851554,7.17391304 5.54347826,7.17391304 L8.80434783,7.17391304 C8.90242859,7.17391304 8.96356989,7.13697359 9.02853261,7.07201087 L14.2459239,1.52853261 C14.3108866,1.46356989 14.3478261,1.40242859 14.3478261,1.30434783 L14.3478261,0.326086957 C14.3478261,0.129925435 14.217901,0 14.0217391,0 L0.326086957,0 Z M5.2173913,7.82608696 L5.2173913,12.7173913 C5.2173913,12.8473167 5.28235402,12.9479449 5.38043478,13.0129076 L8.64130435,14.9694293 C8.67442272,15.0025477 8.73938511,15 8.80434783,15 C8.86931054,15 8.90242859,15.0025477 8.9673913,14.9694293 C9.06547207,14.9044666 9.13043478,14.8038385 9.13043478,14.673913 L9.13043478,7.82608696 L5.2173913,7.82608696 Z"
                id="Shape"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export const FilterIco = (props) => <Icon component={FilterSvg} {...props} />;
export const SeacrhIco = (props) => <Icon component={SearchSvg} {...props} />;
export const MapControlIco = (props) => (
  <Icon component={MapControlSvg} {...props} />
);

export const ExpandSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 0C0.447715 0 0 0.447715 0 1V6H2V2H6V0H1ZM15 16C15.5523 16 16 15.5523 16 15V10H14V14H10V16H15ZM16 1C16 0.447715 15.5523 0 15 0H10V2H14V6H16V1ZM1 16C0.447715 16 0 15.5523 0 15V10H2V14H6V16H1Z"
      fill="#6D8991"
    />
  </svg>
);

export const CollapseSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 6C9 6.55228 9.44771 7 10 7H15V5H11V1H9V6ZM6.00005 7.00006C6.55234 7.00006 7.00005 6.55234 7.00005 6.00006V1.00006H5.00005V5.00006H1.00005V7.00006H6.00005ZM10 9C9.44771 9 9 9.44771 9 10V15H11V11H15V9H10ZM6 9C6.55228 9 7 9.44771 7 10V15H5V11H1V9H6Z"
      fill="#6D8991"
    />
  </svg>
);

export const HideArrowSvg = () => (
  <svg
    width="16"
    height="10"
    viewBox="0 0 16 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1 1L8 8L15 1" stroke="#6D8991" strokeWidth="2" />
  </svg>
);

export const FixedSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 11L11.5 14.5L16.5 9"
      stroke="#56B4A4"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="12" r="9" stroke="#56B4A4" strokeWidth="2" />
  </svg>
);
export const NotFixedSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 7V13M12 15V17" stroke="#FD5E5E" strokeWidth="2" />
    <path
      d="M5 5V4C4.44772 4 4 4.44772 4 5H5ZM6 10V5H4V10H6ZM5 6H10V4H5V6Z"
      fill="#FD5E5E"
    />
    <path
      d="M19 19V20C19.5523 20 20 19.5523 20 19H19ZM18 14V19H20V14H18ZM19 18H14V20H19V18Z"
      fill="#FD5E5E"
    />
    <path
      d="M19 5V4C19.5523 4 20 4.44772 20 5H19ZM18 10V5H20V10H18ZM19 6H14V4H19V6Z"
      fill="#FD5E5E"
    />
    <path
      d="M5 19V20C4.44772 20 4 19.5523 4 19H5ZM6 14V19H4V14H6ZM5 18H10V20H5V18Z"
      fill="#FD5E5E"
    />
  </svg>
);
export const CloseSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99885 6.58681L3.41655 2.00451L2.00234 3.41872L6.58464 8.00102L2.00209 12.5836L3.41631 13.9978L7.99885 9.41523L12.5814 13.9978L13.9956 12.5836L9.41306 8.00102L13.9954 3.41872L12.5811 2.00451L7.99885 6.58681Z"
      fill="#6D8991"
    />
  </svg>
);

export const ExportImgSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 2C4.89543 2 4 2.89543 4 4V18C4 19.1046 4.89543 20 6 20H8V18H6V4H14V8H18V18H16V20H19C19.5523 20 20 19.5523 20 19V8V7.25V6.81895L19.6866 6.52299L15.1866 2.27299L14.8976 2H14.5H14H6ZM11 12V17H8.5L12 22L15.5 17H13V12H11Z"
      fill="#BACAD0"
    />
  </svg>
);
export const TableSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 4H19C19.5304 4 20.0391 4.21071 20.4142 4.58579C20.7893 4.96086 21 5.46957 21 6V18C21 18.5304 20.7893 19.0391 20.4142 19.4142C20.0391 19.7893 19.5304 20 19 20H5C4.46957 20 3.96086 19.7893 3.58579 19.4142C3.21071 19.0391 3 18.5304 3 18V6C3 5.46957 3.21071 4.96086 3.58579 4.58579C3.96086 4.21071 4.46957 4 5 4ZM5 8V12H11V8H5ZM13 8V12H19V8H13ZM5 14V18H11V14H5ZM13 14V18H19V14H13Z"
      fill="#BACAD0"
    />
  </svg>
);

export const OpenCardSvg = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 9V3C22 2.44772 21.5523 2 21 2H15V4H18.5858L9.29289 13.2929L10.7071 14.7071L20 5.41421V9H22ZM2 5C2 3.89543 2.89543 3 4 3H11.5V5H4V20H19V12.5H21V20C21 21.1046 20.1046 22 19 22H4C2.89543 22 2 21.1046 2 20V5Z"
    />
  </svg>
);

const VisibleSvg = () => (
  <svg
    width="22"
    height="15"
    viewBox="0 0 22 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 0C6 0 1.73 3.11 0 7.5C1.73 11.89 6 15 11 15C16 15 20.27 11.89 22 7.5C20.27 3.11 16 0 11 0ZM11 12.5C8.24 12.5 6 10.26 6 7.5C6 4.74 8.24 2.5 11 2.5C13.76 2.5 16 4.74 16 7.5C16 10.26 13.76 12.5 11 12.5ZM8 7.5C8 5.84 9.34 4.5 11 4.5C12.66 4.5 14 5.84 14 7.5C14 9.16 12.66 10.5 11 10.5C9.34 10.5 8 9.16 8 7.5Z"
      fill="#6D8991"
    />
  </svg>
);

const InvisibleSvg = () => (
  <svg
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.01 1.86995L2.42 0.449951L20.15 18.2L18.74 19.61L15.31 16.18C13.97 16.7 12.52 17 11 17C6 17 1.73 13.89 0 9.49995C0.77 7.52995 2.06 5.82995 3.69 4.54995L1.01 1.86995ZM16 9.49995C16 6.73995 13.76 4.49995 11 4.49995C10.49 4.49995 10 4.59995 9.53 4.73995L7.36 2.56995C8.51 2.19995 9.73 1.99995 11 1.99995C16 1.99995 20.27 5.10995 22 9.48995C21.31 11.25 20.21 12.79 18.82 14.02L15.76 10.96C15.9 10.5 16 10.01 16 9.49995ZM11 14.5C8.24 14.5 6 12.26 6 9.49995C6 8.72995 6.18 7.99995 6.49 7.35995L8.06 8.92995C8.03 9.10995 8 9.29995 8 9.49995C8 11.16 9.34 12.5 11 12.5C11.2 12.5 11.38 12.47 11.57 12.43L13.14 14C12.49 14.32 11.77 14.5 11 14.5ZM13.97 9.16995C13.82 7.76995 12.72 6.67995 11.33 6.52995L13.97 9.16995Z"
      fill="#6D8991"
    />
  </svg>
);

export const DeleteFileSvg = () => (
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 10C0 4.47 4.47 0 10 0C15.53 0 20 4.47 20 10C20 15.53 15.53 20 10 20C4.47 20 0 15.53 0 10ZM13.59 15L15 13.59L11.41 10L15 6.41L13.59 5L10 8.59L6.41 5L5 6.41L8.59 10L5 13.59L6.41 15L10 11.41L13.59 15Z"
    />
  </svg>
);

export const Logo = () => (
  <svg
    width="56"
    height="40"
    viewBox="0 0 56 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 13.2252V6.68005H6.50991C8.05214 6.68005 8.8853 7.70329 8.8853 8.92059C8.8853 10.1379 8.05214 11.1611 6.50991 11.1611H4.9854V13.2252H3ZM6.86444 8.92059C6.86444 8.56775 6.59854 8.40897 6.26173 8.40897H5.00313V9.4322H6.26173C6.59854 9.4322 6.86444 9.27342 6.86444 8.92059Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.1544 9.9616C11.1544 7.93277 12.7143 6.57434 14.7706 6.57434C16.4901 6.57434 17.3587 7.57993 17.7665 8.47968L16.047 9.27356C15.8874 8.76195 15.3733 8.3209 14.7706 8.3209C13.8134 8.3209 13.1752 9.04422 13.1752 9.9616C13.1752 10.879 13.8134 11.6023 14.7706 11.6023C15.3556 11.6023 15.8697 11.1613 16.047 10.6496L17.7665 11.4435C17.3765 12.3256 16.5079 13.3665 14.7706 13.3665C12.7143 13.3489 11.1544 11.9728 11.1544 9.9616Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.537 32.1023V25.5571H31.5402V29.0502L33.8269 25.5571H35.8832V32.1023H33.8978V28.3975L31.4693 32.1023H29.537Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38.4713 30.3027L40.1908 29.5089C40.3504 30.0205 40.8644 30.4615 41.538 30.4615C42.2117 30.4615 42.6726 30.144 42.8853 29.65H40.634V27.9211H42.8498C42.6194 27.48 42.1939 27.1801 41.538 27.1801C40.8644 27.1801 40.3504 27.6212 40.1908 28.1328L38.4713 27.3389C38.8613 26.4392 39.7299 25.4336 41.4671 25.4336C43.5235 25.4336 45.0834 26.792 45.0834 28.8208C45.0834 30.832 43.5235 32.2081 41.4671 32.2081C39.7299 32.2257 38.8613 31.1848 38.4713 30.3027Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M51.6069 32.1023L50.1179 29.7912L49.7456 30.2851V32.1023H47.7602V25.5571H49.7456V28.0093L51.4651 25.5571H53.8937L51.4119 28.6092L54 32.1199H51.6069V32.1023Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.4213 1.72266L29.4307 12.643L23.4213 18.6237V1.72266Z"
      fill="url(#paint0_linear_552_16080)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.78174 18.7403L17.7724 24.7209L23.764 18.7403H6.78174Z"
      fill="url(#paint1_linear_552_16080)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.4213 38.5768L17.4296 27.6564L23.4213 21.6758V38.5768Z"
      fill="url(#paint2_linear_552_16080)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43.4703 18.6236L32.4974 12.643L26.488 18.6236H43.4703Z"
      fill="url(#paint3_linear_552_16080)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_552_16080"
        x1="29.4207"
        y1="10.1739"
        x2="23.4165"
        y2="10.1739"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#15AAE2" />
        <stop offset="1" stopColor="#0F4C8A" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_552_16080"
        x1="15.2702"
        y1="24.7145"
        x2="15.2702"
        y2="18.739"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#15AAE2" />
        <stop offset="1" stopColor="#0F4C8A" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_552_16080"
        x1="20.4249"
        y1="38.0943"
        x2="20.4249"
        y2="22.3105"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EC2227" />
        <stop offset="1" stopColor="#FDD800" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_552_16080"
        x1="26.7861"
        y1="15.6359"
        x2="42.7398"
        y2="15.6359"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B3BE35" />
        <stop offset="1" stopColor="#098843" />
      </linearGradient>
    </defs>
  </svg>
);

export const LogoDarkLetters = ({ className = "" }: { className?: string }) => (
  <svg
    width="177"
    height="128"
    viewBox="0 0 177 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M0.403748 39.7386V17.1266H12.5296C17.8576 17.1266 20.736 20.6616 20.736 24.8671C20.736 29.0725 17.8576 32.6076 12.5296 32.6076H7.26282V39.7386H0.403748ZM13.7545 24.8671C13.7545 23.6481 12.8358 23.0996 11.6722 23.0996H7.32407V26.6346H11.6722C12.8358 26.6346 13.7545 26.086 13.7545 24.8671Z"
      fill="#8D8D8D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.575 28.4635C28.575 21.4544 33.9642 16.7614 41.0683 16.7614C47.0087 16.7614 50.0096 20.2354 51.4181 23.3438L45.4777 26.0865C44.9265 24.319 43.1505 22.7953 41.0683 22.7953C37.7612 22.7953 35.5565 25.2942 35.5565 28.4635C35.5565 31.6328 37.7612 34.1317 41.0683 34.1317C43.0893 34.1317 44.8653 32.608 45.4777 30.8405L51.4181 33.5832C50.0708 36.6306 47.07 40.2266 41.0683 40.2266C33.9642 40.1657 28.575 35.4117 28.575 28.4635Z"
      fill="#8D8D8D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M92.0826 104.954V82.3422H99.003V94.41L106.903 82.3422H114.007V104.954H107.148V92.1549L98.758 104.954H92.0826Z"
      fill="#8D8D8D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M122.949 98.7371L128.889 95.9944C129.44 97.7619 131.216 99.2857 133.543 99.2857C135.871 99.2857 137.463 98.1886 138.198 96.482H130.42V90.509H138.075C137.279 88.9853 135.809 87.9492 133.543 87.9492C131.216 87.9492 129.44 89.4729 128.889 91.2404L122.949 88.4977C124.296 85.3894 127.297 81.9153 133.298 81.9153C140.402 81.9153 145.792 86.6083 145.792 93.6174C145.792 100.566 140.402 105.32 133.298 105.32C127.297 105.381 124.296 101.785 122.949 98.7371Z"
      fill="#8D8D8D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M168.329 104.954L163.184 96.9698L161.898 98.6764V104.954H155.039V82.3422H161.898V90.814L167.839 82.3422H176.229L167.655 92.8863L176.596 105.015H168.329V104.954Z"
      fill="#8D8D8D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M70.9542 -0.00012207L91.7152 37.7271L70.9542 58.3888V-0.00012207Z"
      fill="url(#paint0_linear_1590_23354)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.4686 58.7916L51.4385 79.4532L72.1382 58.7916H13.4686Z"
      fill="url(#paint1_linear_1590_23354)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M70.9542 127.322L50.2545 89.5947L70.9542 68.9331V127.322Z"
      fill="url(#paint2_linear_1590_23354)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M140.219 58.3888L102.31 37.7272L81.5491 58.3888H140.219Z"
      fill="url(#paint3_linear_1590_23354)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1590_23354"
        x1="91.6809"
        y1="29.1969"
        x2="70.9378"
        y2="29.1969"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#15AAE2" />
        <stop offset="1" stopColor="#0F4C8A" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1590_23354"
        x1="42.7942"
        y1="79.4309"
        x2="42.7942"
        y2="58.7871"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#15AAE2" />
        <stop offset="1" stopColor="#0F4C8A" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1590_23354"
        x1="60.6023"
        y1="125.655"
        x2="60.6023"
        y2="71.1262"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EC2227" />
        <stop offset="1" stopColor="#FDD800" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1590_23354"
        x1="82.579"
        y1="48.0669"
        x2="137.695"
        y2="48.0669"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B3BE35" />
        <stop offset="1" stopColor="#098843" />
      </linearGradient>
    </defs>
  </svg>
);

export const EditSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.1778 2.33106L10.6539 1.80713L10.1237 2.32466L2.80949 9.46333L2.61754 9.65067L2.58793 9.91724L2.25459 12.9172C2.22943 13.1437 2.30857 13.3693 2.46967 13.5304C2.63078 13.6915 2.85638 13.7706 3.08283 13.7455L6.08283 13.4121L6.34943 13.3825L6.53677 13.1905L13.6749 5.87586L14.1924 5.34561L13.6685 4.82171L11.1778 2.33106ZM3.84895 12.1511L4.04913 10.3495L8.96011 5.55631L10.4434 7.0396L5.65058 11.9509L3.84895 12.1511ZM11.4911 5.96598L12.0839 5.35848L10.6411 3.91565L10.0337 4.50853L11.4911 5.96598Z"
    />
  </svg>
);

const AddSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="#fff"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M21 11L3 11L3 13L21 13L21 11Z" fill="#fff" />
    <path d="M12 3L12 21" stroke="#fff" strokeWidth="3" strokeMiterlimit="10" />
  </svg>
);

const PlusSvg = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 11L21 11V13L3 13L3 11Z" />
    <path d="M11 21L11 3L13 3L13 21H11Z" />
  </svg>
);

const MinusSvg = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 11L21 11V13L3 13L3 11Z" />
  </svg>
);

const DeleteSvg = () => (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 0H4V2H12V0ZM16 6H14V14.024C14 16.1297 12.4059 18 10.2733 18H5.72673C3.59415 18 2 16.1297 2 14.024V6H0V4H16V6ZM4 6H12V14.024C12 15.1932 11.1404 16 10.2733 16H5.72673C4.85961 16 4 15.1932 4 14.024V6Z"
      fill="currentColor"
    />
  </svg>
);

const DownloadSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12ZM12 15L17.55 9.54L16.13 8.13L13 11.25V2H11V11.25L7.88 8.13L6.46 9.55L12 15Z"
      fill="#6D8991"
    />
  </svg>
);

export const LampSvg = (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3253 5.46289C10.942 5.46289 10.5503 5.49622 10.1586 5.57956C7.85863 6.02122 6.0253 7.87956 5.59196 10.1796C5.19196 12.3546 5.99196 14.3546 7.44196 15.6462C7.8003 15.9629 7.99196 16.4046 7.99196 16.8712V18.7962C7.99196 19.7129 8.74196 20.4629 9.65863 20.4629H9.89196C10.1836 20.9629 10.7086 21.2962 11.3253 21.2962C11.942 21.2962 12.4753 20.9629 12.7586 20.4629H12.992C13.9086 20.4629 14.6586 19.7129 14.6586 18.7962V16.8712C14.6586 16.4129 14.842 15.9629 15.192 15.6546C16.4003 14.5879 17.1586 13.0296 17.1586 11.2962C17.1586 8.07122 14.5503 5.46289 11.3253 5.46289ZM11.742 14.6296H10.9086V12.4712L9.38363 10.9546L9.9753 10.3629L11.3253 11.7129L12.6753 10.3629L13.267 10.9546L11.742 12.4796V14.6296V14.6296ZM12.5753 18.7962C12.567 18.7962 12.5586 18.7879 12.5503 18.7879V18.7962H10.1003V18.7879C10.092 18.7879 10.0836 18.7962 10.0753 18.7962C9.84196 18.7962 9.65863 18.6129 9.65863 18.3796C9.65863 18.1462 9.84196 17.9629 10.0753 17.9629C10.0836 17.9629 10.092 17.9712 10.1003 17.9712V17.9629H12.5503V17.9712C12.5586 17.9712 12.567 17.9629 12.5753 17.9629C12.8086 17.9629 12.992 18.1462 12.992 18.3796C12.992 18.6129 12.8086 18.7962 12.5753 18.7962ZM12.5753 17.1296H10.0753C9.84196 17.1296 9.65863 16.9462 9.65863 16.7129C9.65863 16.4796 9.84196 16.2962 10.0753 16.2962H12.5753C12.8086 16.2962 12.992 16.4796 12.992 16.7129C12.992 16.9462 12.8086 17.1296 12.5753 17.1296Z"
      fill="#AAC1CB"
    />
    <path
      d="M18.7451 3.20983C18.3551 2.81983 17.7251 2.81983 17.3351 3.20983L16.9451 3.59983C16.5551 3.98983 16.5651 4.61983 16.9451 4.99983L16.9551 5.00983C17.3451 5.39983 17.9751 5.39983 18.3651 5.00983L18.7551 4.61983C19.1351 4.21983 19.1351 3.59983 18.7451 3.20983ZM11.0051 -0.000172622L10.9951 -0.000172623C10.4451 -0.000172671 10.0051 0.439827 10.0051 0.989827L10.0051 1.94983C10.0051 2.49983 10.4451 2.93983 10.9951 2.93983L11.0051 2.93983C11.5551 2.93983 11.9951 2.49983 11.9951 1.94983L11.9951 0.989827C11.9951 0.439827 11.5551 -0.000172574 11.0051 -0.000172622ZM19.9851 11.9498L21.0051 11.9498C21.5551 11.9498 21.9951 11.5098 21.9951 10.9598L21.9951 10.9498C21.9951 10.3998 21.5551 9.95983 21.0051 9.95983L19.9951 9.95983C19.4451 9.95983 19.0051 10.3998 19.0051 10.9498L19.0051 10.9598C18.9951 11.5098 19.4351 11.9498 19.9851 11.9498ZM2.99512 10.9598L2.99512 10.9498C2.99512 10.3998 2.55512 9.95983 2.00512 9.95983L0.995117 9.95983C0.445117 9.95983 0.00511755 10.3998 0.0051175 10.9498L0.0051175 10.9598C0.00511745 11.5098 0.445117 11.9498 0.995117 11.9498L2.00512 11.9498C2.55512 11.9498 2.99512 11.5098 2.99512 10.9598ZM5.05512 3.58983L4.66512 3.19983C4.27512 2.80983 3.64512 2.80983 3.25512 3.19983C2.86512 3.58983 2.86512 4.21983 3.25512 4.60983L3.64512 4.99983C4.03512 5.38983 4.66512 5.37983 5.04512 4.99983C5.44512 4.59983 5.44512 3.97983 5.05512 3.58983Z"
      fill="#AAC1CB"
    />
  </svg>
);

export const EarpieceSvg = (
  <svg
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.925 0.849992C4.34417 1.10833 0.875 4.59999 0.875 8.59166V14.1667C0.875 15.55 2.15917 16.6667 3.75 16.6667H4.70833C5.7625 16.6667 6.625 15.9167 6.625 15V11.6667C6.625 10.75 5.7625 9.99999 4.70833 9.99999H2.79167V8.57499C2.79167 5.37499 5.62833 2.59166 9.29875 2.49999C13.1033 2.40833 16.2083 5.04999 16.2083 8.33333V9.99999H14.2917C13.2375 9.99999 12.375 10.75 12.375 11.6667V15C12.375 15.9167 13.2375 16.6667 14.2917 16.6667H16.2083V17.5H10.4583C9.93125 17.5 9.5 17.875 9.5 18.3333C9.5 18.7917 9.93125 19.1667 10.4583 19.1667H15.25C16.8408 19.1667 18.125 18.05 18.125 16.6667V8.33333C18.125 4.02499 13.9467 0.566659 8.925 0.849992Z"
      fill="#AAC1CB"
    />
  </svg>
);

export const StateProgramsSvg = (
  <svg
    width="23"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.249 8.05913C15.8894 7.73172 15.3723 7.73917 15.0756 7.83434C15.2699 7.58643 15.7227 7.38317 15.8561 7.3585C15.9577 7.39805 16.249 7.70902 16.249 8.05913ZM17.3971 6.70328C17.1606 5.38934 14.2208 6.25995 12.7404 5.70186C12.712 6.08489 13.1961 6.69858 13.6592 6.92574C12.8676 7.6393 12.1569 9.07697 12.0136 10.8335C11.8706 9.07697 11.1599 7.6393 10.3683 6.92574C10.8314 6.69858 11.3159 6.08489 11.2871 5.70186C9.80675 6.25995 6.86694 5.38934 6.63004 6.70328C6.5802 6.98135 6.70901 7.4051 6.84815 7.5269C6.87307 7.43878 7.00302 7.15054 7.41281 7.08592C9.48398 6.76086 11.2132 10.0764 9.65226 11.417C9.62843 11.4374 9.6419 11.475 9.67409 11.475H14.3538C14.3856 11.475 14.399 11.4374 14.3757 11.417C12.8143 10.0764 14.5435 6.76086 16.6147 7.08592C17.0249 7.15054 17.1544 7.43878 17.1794 7.5269C17.3185 7.4051 17.4473 6.98135 17.3971 6.70328ZM17.9008 3.68767C17.8636 3.56352 19.078 3.56038 19.078 4.34993C19.078 4.87903 18.3516 5.12968 18.3516 5.67876C18.3516 5.9345 18.6165 6.12209 18.6977 6.12209C18.5107 5.24052 19.2842 5.70186 19.4932 5.86674C19.078 4.68126 20.0126 4.6887 19.9206 4.1451C19.8566 3.76521 19.0443 3.87996 18.7503 3.68767C18.2285 3.34655 17.6114 2.01929 17.2046 3.34655C17.9629 4.07774 17.5217 5.15397 16.5591 5.15397C16.5591 5.15397 16.5538 5.3118 16.5626 5.32433C17.7106 5.26597 18.1109 4.38948 17.9008 3.68767ZM4.50638 5.86674C4.71529 5.70186 5.48886 5.24052 5.30218 6.12209C5.38306 6.12209 5.64794 5.9345 5.64794 5.67876C5.64794 5.12968 4.92153 4.87903 4.92153 4.34993C4.92153 3.56038 6.13593 3.56352 6.09874 3.68767C5.88906 4.38948 6.28925 5.26597 7.43734 5.32433C7.44577 5.3118 7.44041 5.15397 7.44041 5.15397C6.47824 5.15397 6.03702 4.07774 6.79488 3.34655C6.38815 2.01929 5.77099 3.34655 5.24927 3.68767C4.95526 3.87996 4.14298 3.76521 4.07896 4.1451C3.98734 4.6887 4.92153 4.68126 4.50638 5.86674ZM7.76624 8.05913C8.12619 7.73172 8.64332 7.73917 8.93964 7.83434C8.74603 7.58643 8.29255 7.38317 8.15953 7.3585C8.05796 7.39805 7.76624 7.70902 7.76624 8.05913ZM12.5598 0.709257L11.9997 0L11.4397 0.709257L11.9997 1.45572L12.5598 0.709257ZM15.7568 2.85387L15.3585 2.34983L14.9606 2.85387L15.3585 3.34655L15.7568 2.85387ZM18.9871 17.4236L18.4823 16.8687L17.9775 17.4236L18.4823 17.9104L18.9871 17.4236ZM9.03931 2.85387L8.64101 2.34983L8.24311 2.85387L8.64101 3.34655L9.03931 2.85387ZM7.89849 5.32433H9.38391C10.6328 5.32433 11.1948 4.52812 11.3646 3.83767H12.6353C12.8052 4.52812 13.3667 5.32433 14.616 5.32433H16.1014C16.1014 5.32433 16.3613 4.95814 16.4265 4.77682C16.6611 4.12434 16.3613 3.82004 15.9239 3.82004L15.3585 4.35228L14.7931 3.82004C14.3557 3.82004 14.0559 4.12434 14.2906 4.77682C14.3204 4.86023 14.3922 4.98281 14.46 5.09052C13.9329 5.01532 13.2601 4.64052 13.1126 3.83767C13.1126 3.83767 13.502 3.19499 13.5998 2.93494C13.9509 1.9997 13.5024 1.61747 12.8465 1.61747L11.9997 2.6514L11.1529 1.61747C10.4971 1.61747 10.0486 1.9997 10.4001 2.93494C10.4975 3.19499 10.8873 3.83767 10.8873 3.83767C10.7394 4.64052 10.0666 5.01532 9.53952 5.09052C9.6078 4.98281 9.67911 4.86023 9.70899 4.77682C9.94315 4.12434 9.64421 3.82004 9.20639 3.82004L8.64101 4.35228L8.07559 3.82004C7.63782 3.82004 7.33882 4.12434 7.57303 4.77682C7.6382 4.95814 7.89849 5.32433 7.89849 5.32433ZM23.256 10.107C22.9692 10.2578 21.2871 11.0763 19.1325 10.7736C19.1551 10.6667 19.1735 10.5589 19.1892 10.4513C20.6232 10.2731 21.7889 10.0205 22.5318 9.59123C23.3786 9.10171 23.7489 7.93303 23.3215 7.06359C23.3104 7.04166 23.2797 7.03774 23.2644 7.05615C23.0302 7.33617 21.5574 9.00025 19.2371 9.51757C19.2309 9.39186 19.2203 9.26772 19.2041 9.14433C20.3311 8.48053 21.4313 7.71567 21.9553 7.0162C22.7473 5.95878 22.6744 4.60998 21.9208 3.92226C21.9047 3.90737 21.8786 3.91169 21.8675 3.93009C21.6291 4.33857 19.3973 8.08538 16.947 9.70287C16.9225 9.71926 16.8896 9.74044 16.8566 9.76121C16.7864 9.80549 16.7788 9.90025 16.8386 9.95661C17.1211 10.2225 17.2967 10.5926 17.2967 11.0035C17.2967 11.7178 16.7665 12.3119 16.0657 12.4408C15.7097 12.5124 15.1956 12.4917 14.7019 12.3221C14.6796 12.3146 14.6567 12.33 14.6567 12.353V14.6156C14.6567 14.652 14.7099 14.661 14.7226 14.6261C15.0227 13.8002 15.9213 13.6247 16.3142 13.6247C16.4556 14.5075 16.7082 15.2387 17.0364 15.6323C17.5707 16.2718 18.4432 16.2628 18.8216 15.8206C18.8346 15.8053 18.8307 15.7815 18.8131 15.7713C18.5908 15.6385 17.3189 14.8274 17.0644 13.4982C17.1648 13.4622 17.2629 13.4215 17.3568 13.3733C17.7674 14.079 18.365 14.7076 18.8461 14.9477C19.6542 15.3502 20.394 15.1544 20.7221 14.565C20.734 14.5442 20.7194 14.5184 20.6953 14.5161C20.1954 14.4746 18.6613 14.0179 18.0082 12.9053C18.0829 12.834 18.1561 12.7596 18.2243 12.6804C18.9078 13.2209 19.8742 13.6987 20.5661 13.7963C21.3757 13.9106 22.293 13.6423 22.3153 12.6644C22.3157 12.6449 22.2988 12.6288 22.2788 12.63C21.991 12.648 20.0854 12.7342 18.7276 11.9246C18.7748 11.8318 18.8185 11.737 18.8595 11.6402C18.8595 11.6402 20.9111 12.1439 21.8833 11.9771C22.8492 11.8114 23.415 11.0634 23.3058 10.1329C23.3028 10.1098 23.2766 10.0961 23.256 10.107ZM5.14002 11.6402C5.18104 11.737 5.22512 11.8318 5.27227 11.9246C3.91489 12.7337 2.01011 12.6483 1.72108 12.63C1.70076 12.6288 1.68389 12.6456 1.68427 12.6648C1.70689 13.6423 2.62383 13.9106 3.43342 13.7963C4.12496 13.6987 5.09172 13.2209 5.7752 12.6804C5.84382 12.7596 5.91666 12.834 5.9914 12.9053C5.33782 14.0179 3.80411 14.4746 3.30424 14.5161C3.28009 14.5184 3.26591 14.5442 3.27741 14.565C3.60554 15.1544 4.34538 15.3502 5.15382 14.9477C5.63452 14.7076 6.23214 14.079 6.64269 13.3733C6.73699 13.4215 6.83512 13.4622 6.93517 13.4982C6.68064 14.8274 5.40874 15.6385 5.18641 15.7713C5.16916 15.7815 5.16494 15.8053 5.17797 15.8206C5.55633 16.2628 6.42917 16.2718 6.96354 15.6323C7.29167 15.2387 7.5439 14.5075 7.68535 13.6247C8.07866 13.6247 8.97677 13.8002 9.27698 14.6261C9.28997 14.661 9.34328 14.652 9.34328 14.6156V12.353C9.34328 12.33 9.31985 12.3146 9.29762 12.3221C8.80395 12.4917 8.28987 12.5124 7.93414 12.4408C7.23302 12.3119 6.70287 11.7178 6.70287 11.0035C6.70287 10.5926 6.87882 10.2222 7.16095 9.95628C7.22114 9.90025 7.21308 9.80549 7.14332 9.76121C7.10997 9.74044 7.07701 9.71926 7.05208 9.70287C4.60336 8.08616 2.37274 4.3421 2.13239 3.93088C2.12128 3.91169 2.09444 3.90777 2.07796 3.92265C1.32548 4.61076 1.25226 5.95918 2.04422 7.0162C2.56824 7.71567 3.6684 8.48053 4.79503 9.14433C4.7793 9.26772 4.76819 9.39186 4.76244 9.51757C2.44405 9.00066 0.972427 7.33931 0.735911 7.05732C0.720194 7.03813 0.688761 7.04206 0.678027 7.06399C0.251378 7.93381 0.621678 9.10171 1.46769 9.59123C2.2106 10.0205 3.37631 10.2731 4.81036 10.4513C4.82608 10.5589 4.84447 10.6667 4.86709 10.7736C2.71468 11.0759 1.03338 10.2593 0.744345 10.1074C0.722878 10.0961 0.696811 10.1101 0.694127 10.1336C0.585261 11.0642 1.15068 11.8114 2.11667 11.9771C3.08842 12.1439 5.14002 11.6402 5.14002 11.6402ZM18.4823 18.6252L17.7348 18.0142C17.4366 18.1986 17.2173 18.4916 17.1322 18.835C16.6826 18.9005 15.4566 18.6177 15.5759 18.4301C16.9195 16.4672 15.8917 15.2986 14.6567 15.3636V16.6818C14.6567 17.1052 14.3009 17.4482 13.8628 17.4482H13.0099C12.398 17.4482 11.9997 18.0871 11.9997 18.0871C11.9997 18.0871 11.6015 17.4482 10.9897 17.4482H10.1368C9.69823 17.4482 9.34328 17.1052 9.34328 16.6818V15.3636C8.10817 15.2986 7.07969 16.4672 8.42365 18.4301C8.54174 18.6157 7.2817 18.913 6.6906 18.8378C6.53497 18.6702 6.31034 18.5644 6.05887 18.5644C5.94809 18.5644 5.84267 18.5856 5.74569 18.6228C5.74569 18.6228 3.42307 16.3388 3.38053 16.3164L3.39969 16.2703C3.53194 16.0133 3.32954 15.7333 3.20151 15.7529C3.35024 15.5676 3.35714 14.7565 2.53221 14.569C2.55636 14.7319 2.56863 15.0644 2.56863 15.0644C2.56863 15.0644 1.93191 14.7068 1.61221 15.0154C1.33122 15.3608 1.72108 15.9875 1.72108 15.9875C1.72108 15.9875 1.39524 15.9957 1.23463 15.9816C1.47076 16.8111 2.26273 16.7523 2.43408 16.5886C2.42296 16.7206 2.70931 16.9086 2.95196 16.7578L3.05853 16.7042C3.07731 16.7304 5.33935 18.9502 5.33935 18.9502C5.23547 19.1104 5.18603 19.307 5.22014 19.5166C5.2738 19.8439 5.53639 20.1153 5.87181 20.1858C6.10871 20.2351 6.33143 20.1874 6.51006 20.0789L7.10882 20.6562C7.16211 20.7063 7.23417 20.7377 7.31467 20.7318C7.46111 20.7216 7.57074 20.5982 7.55962 20.4569C7.55502 20.393 7.52359 20.3382 7.48027 20.2966C7.47069 20.2857 6.87039 19.7069 6.87039 19.7069C7.36565 19.3462 8.28834 19.092 9.05421 19.092C9.18878 19.092 9.25205 18.9737 9.20568 18.8578C8.85877 17.9911 9.60469 17.3633 10.3763 17.8744C10.7129 18.0972 11.0549 18.5363 11.3125 19.2686C10.0463 19.587 8.45662 20.4643 8.135 21.4218C8.01119 21.7916 8.4202 22.2956 8.91701 22.397C8.93581 22.4014 8.95382 22.3884 8.95725 22.37C9.21675 20.9405 10.6968 19.8752 11.4669 19.6943C11.5057 19.802 11.493 19.7671 11.5317 19.8745C10.693 20.2865 9.87957 21.1555 9.64724 22.1887C9.54071 22.6618 10.0486 23.0882 10.468 23.2049C10.4891 23.2108 10.5097 23.1956 10.5109 23.1744C10.5906 21.8679 11.1461 20.7584 11.6437 20.2536C11.6571 20.3507 11.6674 20.4502 11.6743 20.5509C11.6743 20.5509 11.1649 22.0254 11.1649 23.1012C11.1649 23.6017 11.8809 23.951 11.9868 24C12.119 23.951 12.8347 23.6017 12.8347 23.1012C12.8347 22.0254 12.3252 20.5509 12.3252 20.5509C12.3325 20.4502 12.3425 20.3507 12.3563 20.2536C12.8535 20.7584 13.4093 21.8676 13.4886 23.1741C13.4898 23.1952 13.5109 23.2108 13.5316 23.2049C13.9513 23.0882 14.4588 22.6618 14.3526 22.1887C14.12 21.1555 13.3069 20.2865 12.4682 19.8745C12.5066 19.7671 12.4939 19.802 12.5326 19.6943C13.3031 19.8752 14.7827 20.9405 15.0423 22.37C15.0457 22.3884 15.0641 22.4014 15.0825 22.397C15.5789 22.2956 15.9887 21.7916 15.8642 21.4218C15.5433 20.4643 13.9532 19.587 12.6871 19.2686C12.9451 18.5363 13.287 18.0972 13.6235 17.8744C14.3949 17.3633 15.1408 17.9911 14.7939 18.8578C14.7475 18.9737 14.8104 19.092 14.9453 19.092C15.8117 19.092 16.8788 19.4171 17.3013 19.853C17.5711 20.2735 18.0698 20.5426 18.6326 20.4851C19.272 20.42 19.7933 19.9211 19.8654 19.3043C19.9283 18.7638 19.6591 18.2786 19.2302 18.0142L18.4823 18.6252ZM12.9727 14.688C13.2391 14.5854 13.6565 14.6685 13.6423 15.0679C13.6389 15.1584 13.7612 15.1584 13.77 15.066C13.8497 14.4679 13.4607 14.2956 13.0535 14.3657C13.0029 14.1601 12.9616 13.9803 12.9144 13.8022C12.8768 13.658 12.863 13.3874 13.0237 13.3874C13.1103 13.3874 13.0754 13.6392 13.0673 13.7477C13.0601 13.8429 13.093 13.9004 13.1674 13.9032C13.2138 13.9051 13.2717 13.8436 13.3062 13.8029C13.5392 13.5291 13.5933 13.1054 13.3204 12.901C13.0919 12.7294 12.5199 12.8571 12.3628 13.1015C12.339 13.0094 12.2255 12.8575 12.1711 12.7913C12.1182 12.7267 12.1044 12.6824 12.1777 12.6257C12.2122 12.5983 12.3164 12.4905 12.3164 12.3793C12.3164 12.3135 12.2674 12.1921 12.1113 12.1921C11.9883 12.1921 11.8514 12.2806 11.8514 12.478C11.8514 12.5219 11.8617 12.5689 11.889 12.6194C11.8111 12.606 11.5999 12.6115 11.4915 12.6393L12.9915 16.9149C13.4208 16.6947 13.7355 16.3462 13.7355 15.9722C13.7355 15.6534 13.2836 15.7591 13.0639 16.0078C12.9934 15.6036 12.9305 15.2304 12.8619 14.8584C12.8431 14.7558 12.8933 14.719 12.9727 14.688ZM10.8517 11.7836L11.1668 12.693C10.8969 12.7596 10.463 12.9641 10.463 13.2347C10.463 13.5949 11.0767 13.8295 11.4317 13.8013C11.414 13.8836 11.4344 13.9568 11.4896 14.0238C11.3607 14.0238 11.1177 14.0861 11.038 14.1754C10.8498 13.9932 10.5554 13.927 10.4155 14.0379C10.2748 14.1495 10.2705 14.3387 10.4174 14.5525C10.5197 14.7006 10.5581 14.8466 10.443 15.0181C10.8708 15.0181 10.7133 14.4405 10.8809 14.4405C10.8589 14.5525 10.8724 14.6821 10.9211 14.8259C10.9533 14.9215 10.9533 14.9892 10.8981 15.0812C10.7601 15.3103 10.5454 15.8367 10.5745 16.3126C10.4343 16.3117 10.363 16.2761 10.4124 16.0772C10.4308 16.0031 10.3867 15.9502 10.3285 16.0415C10.264 16.1422 10.233 16.3141 10.233 16.3877C10.233 16.8115 10.719 16.8968 10.9046 16.8072C11.4412 17.3466 12.4954 17.2027 12.8484 17.0218L10.9924 11.7319C10.9544 11.6321 10.8183 11.6798 10.8517 11.7836ZM10.7873 16.141C10.7489 15.9233 11.0407 15.534 11.4117 15.1584C11.3328 15.4031 11.3819 15.8249 11.5367 15.9703C11.2676 15.9703 10.9479 16.0227 10.7873 16.141Z"
      fill="#AAC1CB"
    />
  </svg>
);

export const SettingsSvg = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.4298 10.98C17.4698 10.66 17.4998 10.34 17.4998 10C17.4998 9.66 17.4698 9.34 17.4298 9.02L19.5398 7.37C19.7298 7.22 19.7798 6.95 19.6598 6.73L17.6598 3.27C17.5698 3.11 17.3998 3.02 17.2198 3.02C17.1598 3.02 17.0998 3.03 17.0498 3.05L14.5598 4.05C14.0398 3.65 13.4798 3.32 12.8698 3.07L12.4898 0.42C12.4598 0.18 12.2498 0 11.9998 0H7.99984C7.74984 0 7.53984 0.18 7.50984 0.42L7.12984 3.07C6.51984 3.32 5.95984 3.66 5.43984 4.05L2.94984 3.05C2.88984 3.03 2.82984 3.02 2.76984 3.02C2.59984 3.02 2.42984 3.11 2.33984 3.27L0.339839 6.73C0.209839 6.95 0.26984 7.22 0.45984 7.37L2.56984 9.02C2.52984 9.34 2.49984 9.67 2.49984 10C2.49984 10.33 2.52984 10.66 2.56984 10.98L0.45984 12.63C0.26984 12.78 0.219839 13.05 0.339839 13.27L2.33984 16.73C2.42984 16.89 2.59984 16.98 2.77984 16.98C2.83984 16.98 2.89984 16.97 2.94984 16.95L5.43984 15.95C5.95984 16.35 6.51984 16.68 7.12984 16.93L7.50984 19.58C7.53984 19.82 7.74984 20 7.99984 20H11.9998C12.2498 20 12.4598 19.82 12.4898 19.58L12.8698 16.93C13.4798 16.68 14.0398 16.34 14.5598 15.95L17.0498 16.95C17.1098 16.97 17.1698 16.98 17.2298 16.98C17.3998 16.98 17.5698 16.89 17.6598 16.73L19.6598 13.27C19.7798 13.05 19.7298 12.78 19.5398 12.63L17.4298 10.98ZM15.4498 9.27C15.4898 9.58 15.4998 9.79 15.4998 10C15.4998 10.21 15.4798 10.43 15.4498 10.73L15.3098 11.86L16.1998 12.56L17.2798 13.4L16.5798 14.61L15.3098 14.1L14.2698 13.68L13.3698 14.36C12.9398 14.68 12.5298 14.92 12.1198 15.09L11.0598 15.52L10.8998 16.65L10.6998 18H9.29984L9.10984 16.65L8.94984 15.52L7.88984 15.09C7.45984 14.91 7.05984 14.68 6.65984 14.38L5.74984 13.68L4.68984 14.11L3.41984 14.62L2.71984 13.41L3.79984 12.57L4.68984 11.87L4.54984 10.74C4.51984 10.43 4.49984 10.2 4.49984 10C4.49984 9.8 4.51984 9.57 4.54984 9.27L4.68984 8.14L3.79984 7.44L2.71984 6.6L3.41984 5.39L4.68984 5.9L5.72984 6.32L6.62984 5.64C7.05984 5.32 7.46984 5.08 7.87984 4.91L8.93984 4.48L9.09984 3.35L9.29984 2H10.6898L10.8798 3.35L11.0398 4.48L12.0998 4.91C12.5298 5.09 12.9298 5.32 13.3298 5.62L14.2398 6.32L15.2998 5.89L16.5698 5.38L17.2698 6.59L16.1998 7.44L15.3098 8.14L15.4498 9.27ZM9.99984 6C7.78984 6 5.99984 7.79 5.99984 10C5.99984 12.21 7.78984 14 9.99984 14C12.2098 14 13.9998 12.21 13.9998 10C13.9998 7.79 12.2098 6 9.99984 6ZM9.99984 12C8.89984 12 7.99984 11.1 7.99984 10C7.99984 8.9 8.89984 8 9.99984 8C11.0998 8 11.9998 8.9 11.9998 10C11.9998 11.1 11.0998 12 9.99984 12Z"
      fill="#AAC1CB"
    />
  </svg>
);

export const DictionarySvg = (
  <svg
    width="22"
    height="18"
    viewBox="0 0 22 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5909 0H2.40909C1.35909 0 0.5 0.952941 0.5 2.11765V15.8824C0.5 17.0471 1.35909 18 2.40909 18H19.5909C20.6409 18 21.5 17.0471 21.5 15.8824V2.11765C21.5 0.952941 20.6409 0 19.5909 0ZM2.40909 15.8824V2.11765H10.0455V15.8824H2.40909ZM19.5909 15.8824H11.9545V2.11765H19.5909V15.8824ZM12.9091 5.82353H18.6364V7.41177H12.9091V5.82353ZM12.9091 8.47059H18.6364V10.0588H12.9091V8.47059ZM12.9091 11.1176H18.6364V12.7059H12.9091V11.1176Z"
      fill="#AAC1CB"
    />
  </svg>
);

export const AddressInvestProgramsSvg = (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.66846 13.9856V13.1523C6.68421 13.1253 6.70142 13.0986 6.72016 13.0724L8.53241 10.5389H9.09742C9.70221 10.5389 10.0902 10.6514 10.333 10.7953C10.6295 10.971 10.8112 11.1748 10.9229 11.4027L10.9281 11.4133L10.9335 11.4239C11.0731 11.6923 11.1426 11.9753 11.1426 12.287C11.1426 12.565 11.0774 12.8365 10.9335 13.1131L10.9299 13.1201L10.9263 13.1272C10.8162 13.3475 10.6344 13.5506 10.333 13.7292C10.0902 13.8732 9.70221 13.9856 9.09742 13.9856H6.66846ZM12.4308 7.37039C11.6765 6.98645 10.8248 6.767 9.89423 6.68951L6.72016 2.25235C6.25019 1.59235 6.72016 0.662354 7.53016 0.662354H16.5902C17.2402 0.662354 17.8502 0.972351 18.2101 1.50235L22.1702 7.08237C22.4202 7.43234 22.4202 7.89236 22.1702 8.24234L18.2202 13.8123C17.8502 14.3423 17.2402 14.6523 16.5902 14.6523H14.9376C14.9612 14.6017 14.9839 14.5506 15.0059 14.499C15.303 13.8024 15.4451 13.0526 15.4451 12.2623C15.4451 11.2131 15.1928 10.2424 14.6686 9.37894C14.1403 8.50894 13.3809 7.84171 12.4308 7.37039ZM5.66847 16.8672H9.09742C9.94744 16.8672 10.7025 16.7558 11.3628 16.533C12.023 16.3019 12.58 15.9801 13.0339 15.5674C13.496 15.1548 13.8468 14.6679 14.0861 14.1067C14.3254 13.5456 14.4451 12.9307 14.4451 12.2623C14.4451 11.3793 14.2347 10.5911 13.8138 9.89792C13.3929 9.20471 12.7822 8.66004 11.9817 8.26391C11.1894 7.85954 10.228 7.65735 9.09742 7.65735H4.37838C3.8261 7.65735 3.37838 8.10506 3.37838 8.65735V14.9856H1.93005C1.41047 14.9856 0.989258 15.4068 0.989258 15.9264C0.989258 16.446 1.41047 16.8672 1.93005 16.8672H3.37838V17.9689H1.92386C1.40769 17.9689 0.989258 18.3874 0.989258 18.9036C0.989258 19.4197 1.40769 19.8382 1.92386 19.8382H3.37838V21.0787C3.37838 21.631 3.8261 22.0787 4.37838 22.0787H4.66847C5.22076 22.0787 5.66847 21.631 5.66847 21.0787V19.8382H7.93999C8.45616 19.8382 8.8746 19.4197 8.8746 18.9036C8.8746 18.3874 8.45616 17.9689 7.94 17.9689H5.66847V16.8672ZM5.66847 14.9856H9.09742C9.81539 14.9856 10.3972 14.8536 10.8428 14.5895C11.2885 14.3254 11.6145 13.9871 11.8208 13.5744C12.0353 13.1618 12.1426 12.7327 12.1426 12.287C12.1426 11.8167 12.0353 11.3751 11.8208 10.9625C11.6145 10.5416 11.2885 10.1991 10.8428 9.93506C10.3972 9.67098 9.81539 9.53894 9.09742 9.53894H6.66847C6.11619 9.53894 5.66847 9.98665 5.66847 10.5389V14.9856Z"
      fill="#AAC1CB"
    />
  </svg>
);

export const RsoInvestProgramsSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.6709 7.66092C8.67175 3.43115 12.1034 0 16.3334 0C20.5639 0 23.9959 3.432 23.9959 7.66249C23.9959 11.893 20.5639 15.325 16.3334 15.325C15.6878 15.325 15.0609 15.2451 14.4619 15.0946C14.6548 14.5148 14.7478 13.9018 14.7478 13.2623C14.7478 12.2131 14.4955 11.2424 13.9713 10.3789C13.4431 9.50895 12.6837 8.84172 11.7335 8.3704C10.8392 7.91519 9.80807 7.69121 8.6709 7.66092ZM15.9341 8.99844V12.1771C15.9341 12.584 16.4793 12.7145 16.6635 12.346L19.3969 6.87935C19.5197 6.62598 19.3354 6.32655 19.0514 6.32655H17.1012V3.10953C17.1012 2.7026 16.556 2.57208 16.3795 2.93294L13.554 8.43796C13.4158 8.69133 13.6078 8.99844 13.8918 8.99844H15.9341Z"
      fill="#AAC1CB"
    />
    <path
      d="M8.40015 17.8672H1.23279C0.7132 17.8672 0.291992 17.446 0.291992 16.9264V16.9264C0.291992 16.4068 0.7132 15.9856 1.23279 15.9856H8.40015C9.11813 15.9856 9.69994 15.8536 10.1456 15.5895C10.5912 15.3254 10.9172 14.9871 11.1235 14.5744C11.3381 14.1618 11.4454 13.7327 11.4454 13.287C11.4454 12.8166 11.3381 12.3751 11.1235 11.9625C10.9172 11.5416 10.5912 11.1991 10.1456 10.9351C9.69994 10.671 9.11813 10.5389 8.40015 10.5389H5.97121C5.41892 10.5389 4.97121 10.9867 4.97121 11.5389V22.0787C4.97121 22.631 4.52349 23.0787 3.97121 23.0787H3.68111C3.12883 23.0787 2.68111 22.631 2.68111 22.0787V9.65735C2.68111 9.10506 3.12883 8.65735 3.68111 8.65735H8.40015C9.53076 8.65735 10.4922 8.85954 11.2844 9.26391C12.0849 9.66004 12.6956 10.2047 13.1165 10.8979C13.5374 11.5911 13.7478 12.3793 13.7478 13.2623C13.7478 13.9307 13.6282 14.5456 13.3888 15.1067C13.1495 15.6679 12.7988 16.1548 12.3366 16.5674C11.8827 16.9801 11.3257 17.3019 10.6655 17.533C10.0053 17.7558 9.25017 17.8672 8.40015 17.8672ZM7.24273 18.9689C7.7589 18.9689 8.17733 19.3874 8.17733 19.9036V19.9036C8.17733 20.4197 7.7589 20.8382 7.24273 20.8382H1.2266C0.710429 20.8382 0.291992 20.4197 0.291992 19.9036V19.9036C0.291992 19.3874 0.710429 18.9689 1.2266 18.9689H7.24273Z"
      fill="#AAC1CB"
    />
  </svg>
);

export const ConstructorSvg = (
  <svg
    width="25"
    height="23"
    viewBox="0 0 25 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2969 1.22734C17.4551 1.27235 17.5981 1.35884 17.7144 1.47514L23.8383 7.59904C24.2289 7.98957 24.2289 8.62275 23.8383 9.01325L22.6665 10.1852C22.276 10.5757 21.6428 10.5757 21.2523 10.1852L19.2003 8.13322C18.8098 7.74269 18.1766 7.74269 17.7861 8.13322L13.5797 12.3396L15.6898 14.4498C15.9874 14.7474 16.4371 14.8137 16.8449 14.7098C18.0825 14.3946 19.45 14.7213 20.4186 15.6899C21.2038 16.475 21.5672 17.5223 21.5087 18.5501C21.4693 19.2423 20.6445 19.4064 20.1542 18.9161L18.8799 17.6417C18.4893 17.2512 17.8562 17.2512 17.4657 17.6417L17.0773 18.0301C16.6868 18.4206 16.6868 19.0538 17.0773 19.4443L18.3513 20.7183C18.8417 21.2087 18.6775 22.0335 17.9851 22.0727C16.9577 22.1309 15.9108 21.7675 15.1259 20.9826C14.1569 20.0135 13.8303 18.6452 14.1463 17.4072C14.2504 16.9992 14.1842 16.5492 13.8864 16.2515L11.7771 14.1422L4.98427 20.935C4.59376 21.3255 3.96058 21.3255 3.57008 20.935L2.75758 20.1225C2.36702 19.732 2.36702 19.0988 2.75758 18.7083L9.55043 11.9155L6.71583 9.08091C6.41823 8.7833 5.96858 8.71696 5.56068 8.82087C4.32301 9.13621 2.95546 8.80955 1.98677 7.84089C1.20167 7.0558 0.838331 6.00865 0.89668 4.981C0.935987 4.28871 1.76082 4.12461 2.25111 4.61491L3.52528 5.88911C3.91585 6.27961 4.54896 6.27961 4.93953 5.88911L5.32783 5.50074C5.7184 5.11024 5.7184 4.47706 5.32783 4.08653L4.05378 2.81251C3.56349 2.32215 3.72761 1.49732 4.41993 1.45808C5.44746 1.39982 6.49446 1.76319 7.27949 2.5482C8.24849 3.51719 8.57503 4.88532 8.25917 6.12336C8.15504 6.53135 8.22133 6.98124 8.51906 7.27897L11.353 10.1129L15.5594 5.9065C15.9499 5.51597 15.9499 4.88279 15.5594 4.49229L12.302 1.23484C12.1771 1.11003 12.1771 0.907694 12.302 0.782877C12.3571 0.727763 12.4304 0.69456 12.5083 0.690379C14.1166 0.60435 15.7365 0.783335 17.2969 1.22734Z"
      fill="#AAC1CB"
    />
  </svg>
);

export const SiderTriggerSvg = (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.021 18H16.1119V16H3.021V18ZM3.021 13H13.0909V11H3.021V13ZM3.021 6V8H16.1119V6H3.021ZM21.1469 15.59L17.5418 12L21.1469 8.41L19.727 7L14.692 12L19.727 17L21.1469 15.59Z"
      fill="#AAC1CB"
    />
  </svg>
);
export const HeatSeasonSvg = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
      fill="#AAC1CB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4898 9.37996C11.9198 8.15996 11.6598 6.73996 10.6798 5.75996C9.56984 4.64996 7.88984 4.45996 6.57984 5.16996L8.92984 7.51996L7.51984 8.92996L5.16984 6.57996C4.45984 7.89996 4.64984 9.56996 5.75984 10.68C6.73984 11.66 8.15984 11.92 9.37984 11.49L12.7898 14.9C12.9898 15.1 13.2998 15.1 13.4998 14.9L14.8998 13.5C15.0998 13.3 15.0998 12.99 14.8998 12.79L11.4898 9.37996Z"
      fill="#AAC1CB"
    />
  </svg>
);

export const TechConnectionsSvg = (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 14H11V16H4V14ZM4 10H14V12H4V10ZM4 6H14V8H4V6ZM16 2H11.82C11.4 0.84 10.3 0 9 0C7.7 0 6.6 0.84 6.18 2H2C1.86 2 1.73 2.01 1.6 2.04C1.21 2.12 0.86 2.32 0.59 2.59C0.41 2.77 0.26 2.99 0.16 3.23C0.0600001 3.46 0 3.72 0 4V18C0 18.27 0.0600001 18.54 0.16 18.78C0.26 19.02 0.41 19.23 0.59 19.42C0.86 19.69 1.21 19.89 1.6 19.97C1.73 19.99 1.86 20 2 20H16C17.1 20 18 19.1 18 18V4C18 2.9 17.1 2 16 2ZM9 1.75C9.41 1.75 9.75 2.09 9.75 2.5C9.75 2.91 9.41 3.25 9 3.25C8.59 3.25 8.25 2.91 8.25 2.5C8.25 2.09 8.59 1.75 9 1.75ZM16 18H2V4H16V18Z"
      fill="#AAC1CB"
    />
  </svg>
);

export const ObjectsSvg = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM14.59 5.58L8 12.17L5.41 9.59L4 11L8 15L16 7L14.59 5.58Z"
      fill="#AAC1CB"
    />
  </svg>
);

export const MapSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 0L17.34 0.03L12 2.1L6 0L0.36 1.9C0.15 1.97 0 2.15 0 2.38V17.5C0 17.78 0.22 18 0.5 18L0.66 17.97L6 15.9L12 18L17.64 16.1C17.85 16.03 18 15.85 18 15.62V0.5C18 0.22 17.78 0 17.5 0ZM7 2.47L11 3.87V15.53L7 14.13V2.47ZM2 3.46L5 2.45V14.15L2 15.31V3.46ZM16 14.54L13 15.55V3.86L16 2.7V14.54Z"
      fill="#AAC1CB"
    />
  </svg>
);

export const MapFieldSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 0L17.34 0.03L12 2.1L6 0L0.36 1.9C0.15 1.97 0 2.15 0 2.38V17.5C0 17.78 0.22 18 0.5 18L0.66 17.97L6 15.9L12 18L17.64 16.1C17.85 16.03 18 15.85 18 15.62V0.5C18 0.22 17.78 0 17.5 0ZM7 2.47L11 3.87V15.53L7 14.13V2.47ZM2 3.46L5 2.45V14.15L2 15.31V3.46ZM16 14.54L13 15.55V3.86L16 2.7V14.54Z"
      fill="currentColor"
      stroke="currentColor"
    />
  </svg>
);

export const MapSvgForIcon = () => MapSvg;
export const MapSvgForField = () => MapFieldSvg;

export const SearchInputSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.71 14H15.5L20.49 19L19 20.49L14 15.5V14.71L13.73 14.43C12.59 15.41 11.11 16 9.5 16C5.91 16 3 13.09 3 9.5C3 5.91 5.91 3 9.5 3C13.09 3 16 5.91 16 9.5C16 11.11 15.41 12.59 14.43 13.73L14.71 14ZM5 9.5C5 11.99 7.01 14 9.5 14C11.99 14 14 11.99 14 9.5C14 7.01 11.99 5 9.5 5C7.01 5 5 7.01 5 9.5Z"
      fill="white"
    />
  </svg>
);

const DropDownSvg = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 14L12 9L17 14H7Z" />
  </svg>
);

const DropDownWithoutSpaceSvg = () => (
  <svg viewBox="0 0 6 11" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.65723 5.07178L0.657227 10.0718L0.657228 0.0717773L5.65723 5.07178Z" />
  </svg>
);

const closeMediumSvg = () => (
  <svg
    width="19"
    height="16"
    viewBox="0 0 19 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.87947 6.58681L5.29717 2.00452L3.88295 3.41873L8.46525 8.00103L3.88271 12.5836L5.29692 13.9978L9.87947 9.41524L14.462 13.9978L15.8762 12.5836L11.2937 8.00103L15.876 3.41873L14.4618 2.00452L9.87947 6.58681Z"
    />
  </svg>
);

const SettingsFunc = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.4298 12.98C19.4698 12.66 19.4998 12.34 19.4998 12C19.4998 11.66 19.4698 11.34 19.4298 11.02L21.5398 9.37C21.7298 9.22 21.7798 8.95 21.6598 8.73L19.6598 5.27C19.5698 5.11 19.3998 5.02 19.2198 5.02C19.1598 5.02 19.0998 5.03 19.0498 5.05L16.5598 6.05C16.0398 5.65 15.4798 5.32 14.8698 5.07L14.4898 2.42C14.4598 2.18 14.2498 2 13.9998 2H9.99984C9.74984 2 9.53984 2.18 9.50984 2.42L9.12984 5.07C8.51984 5.32 7.95984 5.66 7.43984 6.05L4.94984 5.05C4.88984 5.03 4.82984 5.02 4.76984 5.02C4.59984 5.02 4.42984 5.11 4.33984 5.27L2.33984 8.73C2.20984 8.95 2.26984 9.22 2.45984 9.37L4.56984 11.02C4.52984 11.34 4.49984 11.67 4.49984 12C4.49984 12.33 4.52984 12.66 4.56984 12.98L2.45984 14.63C2.26984 14.78 2.21984 15.05 2.33984 15.27L4.33984 18.73C4.42984 18.89 4.59984 18.98 4.77984 18.98C4.83984 18.98 4.89984 18.97 4.94984 18.95L7.43984 17.95C7.95984 18.35 8.51984 18.68 9.12984 18.93L9.50984 21.58C9.53984 21.82 9.74984 22 9.99984 22H13.9998C14.2498 22 14.4598 21.82 14.4898 21.58L14.8698 18.93C15.4798 18.68 16.0398 18.34 16.5598 17.95L19.0498 18.95C19.1098 18.97 19.1698 18.98 19.2298 18.98C19.3998 18.98 19.5698 18.89 19.6598 18.73L21.6598 15.27C21.7798 15.05 21.7298 14.78 21.5398 14.63L19.4298 12.98ZM17.4498 11.27C17.4898 11.58 17.4998 11.79 17.4998 12C17.4998 12.21 17.4798 12.43 17.4498 12.73L17.3098 13.86L18.1998 14.56L19.2798 15.4L18.5798 16.61L17.3098 16.1L16.2698 15.68L15.3698 16.36C14.9398 16.68 14.5298 16.92 14.1198 17.09L13.0598 17.52L12.8998 18.65L12.6998 20H11.2998L11.1098 18.65L10.9498 17.52L9.88984 17.09C9.45984 16.91 9.05984 16.68 8.65984 16.38L7.74984 15.68L6.68984 16.11L5.41984 16.62L4.71984 15.41L5.79984 14.57L6.68984 13.87L6.54984 12.74C6.51984 12.43 6.49984 12.2 6.49984 12C6.49984 11.8 6.51984 11.57 6.54984 11.27L6.68984 10.14L5.79984 9.44L4.71984 8.6L5.41984 7.39L6.68984 7.9L7.72984 8.32L8.62984 7.64C9.05984 7.32 9.46984 7.08 9.87984 6.91L10.9398 6.48L11.0998 5.35L11.2998 4H12.6898L12.8798 5.35L13.0398 6.48L14.0998 6.91C14.5298 7.09 14.9298 7.32 15.3298 7.62L16.2398 8.32L17.2998 7.89L18.5698 7.38L19.2698 8.59L18.1998 9.44L17.3098 10.14L17.4498 11.27ZM11.9998 8C9.78984 8 7.99984 9.79 7.99984 12C7.99984 14.21 9.78984 16 11.9998 16C14.2098 16 15.9998 14.21 15.9998 12C15.9998 9.79 14.2098 8 11.9998 8ZM11.9998 14C10.8998 14 9.99984 13.1 9.99984 12C9.99984 10.9 10.8998 10 11.9998 10C13.0998 10 13.9998 10.9 13.9998 12C13.9998 13.1 13.0998 14 11.9998 14Z" />
  </svg>
);

export const ExpandCloseSvg = () => (
  <svg
    width="10"
    height="5"
    viewBox="0 0 10 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5 5L0 0H10L5 5Z" fill="#6D8991" />
  </svg>
);

export const ExpandOnSvg = () => (
  <svg
    width="10"
    height="5"
    viewBox="0 0 10 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5 -4.37114e-07L10 5L0 5L5 -4.37114e-07Z" fill="#6D8991" />
  </svg>
);

export const OpenTreeSvg = () => (
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.10808 0.481934C2.86 0.481934 0.223877 3.11806 0.223877 6.36614C0.223877 9.61422 2.86 12.2503 6.10808 12.2503C9.35617 12.2503 11.9923 9.61422 11.9923 6.36614C11.9923 3.11806 9.35617 0.481934 6.10808 0.481934ZM6.10808 11.0735C3.51315 11.0735 1.40072 8.96108 1.40072 6.36614C1.40072 3.77121 3.51315 1.65878 6.10808 1.65878C8.70302 1.65878 10.8155 3.77121 10.8155 6.36614C10.8155 8.96108 8.70302 11.0735 6.10808 11.0735Z"
      fill="#56B4A4"
    />
    <path
      d="M3.03259 5.36621L6.10804 8.44166L9.18348 5.36621"
      stroke="#56B4A4"
    />
  </svg>
);

export const CloseTreeSvg = () => (
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.05705 12.0044C9.30501 12.0325 11.9639 9.41939 11.9921 6.17143C12.0203 2.92347 9.40714 0.264571 6.15918 0.236384C2.91122 0.208196 0.252321 2.82134 0.224133 6.06931C0.195945 9.31727 2.80909 11.9762 6.05705 12.0044ZM6.14897 1.41318C8.74381 1.4357 10.8378 3.56638 10.8153 6.16122C10.7928 8.75606 8.6621 10.8501 6.06727 10.8276C3.47243 10.805 1.37841 8.67436 1.40093 6.07952C1.42345 3.48468 3.55413 1.39066 6.14897 1.41318Z"
      fill="#56B4A4"
    />
    <path d="M9.15088 7.08643L6.08091 4.00552L3 7.07549" stroke="#56B4A4" />
  </svg>
);

export const FiltersSvg = () => (
  <svg
    width="18"
    height="25"
    viewBox="0 0 18 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.1968 9.33301C15.2308 9.06101 15.2563 8.78901 15.2563 8.50001C15.2563 8.21101 15.2308 7.93901 15.1968 7.66701L16.9903 6.2645C17.1518 6.137 17.1943 5.9075 17.0923 5.7205L15.3923 2.7795C15.3158 2.6435 15.1713 2.567 15.0183 2.567C14.9673 2.567 14.9163 2.5755 14.8738 2.5925L12.7573 3.4425C12.3153 3.1025 11.8393 2.822 11.3208 2.6095L10.9978 0.357C10.9723 0.153 10.7938 0 10.5813 0H7.18126C6.96876 0 6.79026 0.153 6.76476 0.357L6.44176 2.6095C5.92326 2.822 5.44726 3.111 5.00526 3.4425L2.88876 2.5925C2.83776 2.5755 2.78676 2.567 2.73576 2.567C2.59126 2.567 2.44676 2.6435 2.37026 2.7795L0.67026 5.7205C0.55976 5.9075 0.61076 6.137 0.77226 6.2645L2.56576 7.66701C2.53176 7.93901 2.50626 8.21951 2.50626 8.50001C2.50626 8.78051 2.53176 9.06101 2.56576 9.33301L0.77226 10.7355C0.61076 10.863 0.56826 11.0925 0.67026 11.2795L2.37026 14.2205C2.44676 14.3565 2.59126 14.433 2.74426 14.433C2.79526 14.433 2.84626 14.4245 2.88876 14.4075L5.00526 13.5575C5.44726 13.8975 5.92326 14.178 6.44176 14.3905L6.76476 16.643C6.79026 16.847 6.96876 17 7.18126 17H10.5813C10.7938 17 10.9723 16.847 10.9978 16.643L11.3208 14.3905C11.8393 14.178 12.3153 13.889 12.7573 13.5575L14.8738 14.4075C14.9248 14.4245 14.9758 14.433 15.0268 14.433C15.1713 14.433 15.3158 14.3565 15.3923 14.2205L17.0923 11.2795C17.1943 11.0925 17.1518 10.863 16.9903 10.7355L15.1968 9.33301ZM13.5138 7.87951C13.5478 8.14301 13.5563 8.32151 13.5563 8.50001C13.5563 8.67851 13.5393 8.86551 13.5138 9.12051L13.3948 10.081L14.1513 10.676L15.0693 11.39L14.4743 12.4185L13.3948 11.985L12.5108 11.628L11.7458 12.206C11.3803 12.478 11.0318 12.682 10.6833 12.8265L9.78227 13.192L9.64627 14.1525L9.47627 15.3H8.28627L8.12477 14.1525L7.98877 13.192L7.08776 12.8265C6.72226 12.6735 6.38226 12.478 6.04226 12.223L5.26876 11.628L4.36776 11.9935L3.28826 12.427L2.69326 11.3985L3.61126 10.6845L4.36776 10.0895L4.24876 9.12901C4.22326 8.86551 4.20626 8.67001 4.20626 8.50001C4.20626 8.33001 4.22326 8.13451 4.24876 7.87951L4.36776 6.919L3.61126 6.324L2.69326 5.61L3.28826 4.5815L4.36776 5.015L5.25176 5.372L6.01676 4.794C6.38226 4.522 6.73076 4.318 7.07926 4.1735L7.98027 3.808L8.11627 2.8475L8.28627 1.7H9.46777L9.62927 2.8475L9.76527 3.808L10.6663 4.1735C11.0318 4.3265 11.3718 4.522 11.7118 4.777L12.4853 5.372L13.3863 5.0065L14.4658 4.573L15.0608 5.6015L14.1513 6.324L13.3948 6.919L13.5138 7.87951ZM8.88127 5.1C7.00276 5.1 5.48126 6.6215 5.48126 8.50001C5.48126 10.3785 7.00276 11.9 8.88127 11.9C10.7598 11.9 12.2813 10.3785 12.2813 8.50001C12.2813 6.6215 10.7598 5.1 8.88127 5.1ZM8.88127 10.2C7.94627 10.2 7.18126 9.43501 7.18126 8.50001C7.18126 7.565 7.94627 6.8 8.88127 6.8C9.81627 6.8 10.5813 7.565 10.5813 8.50001C10.5813 9.43501 9.81627 10.2 8.88127 10.2Z"
      fill="#6D8991"
    />
    <path d="M8.87891 25L3.87891 20H13.8789L8.87891 25Z" fill="#6D8991" />
  </svg>
);

export const NoDataSvg = () => (
  <svg
    width="192"
    height="192"
    viewBox="0 0 192 192"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M103.5 15.8448C141.973 19.3993 172.601 50.0269 176.155 88.5H103.5V88.3924V88.1139V87.8357V87.5577V87.28V87.0025V86.7253V86.4483V86.1716V85.8952V85.619V85.3431V85.0674V84.792V84.5169V84.242V83.9674V83.6931V83.419V83.1452V82.8717V82.5985V82.3255V82.0528V81.7804V81.5083V81.2364V80.9648V80.6935V80.4225V80.1518V79.8814V79.6113V79.3414V79.0718V78.8026V78.5336V78.2649V77.9966V77.7285V77.4607V77.1932V76.926V76.6592V76.3926V76.1263V75.8604V75.5947V75.3294V75.0644V74.7997V74.5353V74.2712V74.0074V73.744V73.4809V73.2181V72.9556V72.6934V72.4316V72.1701V71.9089V71.6481V71.3876V71.1274V70.8675V70.608V70.3488V70.09V69.8315V69.5733V69.3155V69.058V68.8009V68.5441V68.2877V68.0316V67.7758V67.5204V67.2654V67.0107V66.7564V66.5024V66.2488V65.9955V65.7426V65.4901V65.2379V64.9861V64.7347V64.4836V64.2329V63.9826V63.7326V63.483V63.2338V62.985V62.7365V62.4884V62.2407V61.9934V61.7464V61.4999V61.2537V61.0079V60.7625V60.5175V60.2729V60.0286V59.7848V59.5413V59.2983V59.0556V58.8134V58.5715V58.3301V58.089V57.8484V57.6081V57.3683V57.1288V56.8898V56.6512V56.413V56.1752V55.9379V55.7009V55.4644V55.2282V54.9925V54.7573V54.5224V54.288V54.054V53.8204V53.5872V53.3545V53.1222V52.8904V52.6589V52.4279V52.1974V51.9673V51.7376V51.5084V51.2796V51.0512V50.8233V50.5958V50.3688V50.1422V49.9161V49.6904V49.4652V49.2405V49.0161V48.7923V48.5689V48.346V48.1235V47.9015V47.6799V47.4588V47.2382V47.018V46.7984V46.5791V46.3604V46.1421V45.9243V45.707V45.4902V45.2738V45.0579V44.8425V44.6276V44.4131V44.1992V43.9857V43.7727V43.5602V43.3482V43.1367V42.9257V42.7151V42.5051V42.2956V42.0865V41.878V41.6699V41.4624V41.2554V41.0488V40.8428V40.6373V40.4323V40.2278V40.0238V39.8204V39.6174V39.415V39.213V39.0116V38.8108V38.6104V38.4105V38.2112V38.0124V37.8142V37.6164V37.4192V37.2225V37.0264V36.8308V36.6357V36.4412V36.2472V36.0537V35.8608V35.6684V35.4765V35.2852V35.0945V34.9043V34.7146V34.5255V34.337V34.149V33.9615V33.7746V33.5883V33.4025V33.2173V33.0326V32.8485V32.6649V32.482V32.2996V32.1177V31.9364V31.7557V31.5756V31.396V31.2171V31.0386V30.8608V30.6835V30.5069V30.3308V30.1553V29.9803V29.806V29.6322V29.459V29.2864V29.1144V28.943V28.7722V28.602V28.4324V28.2634V28.0949V27.9271V27.7599V27.5932V27.4272V27.2618V27.097V26.9328V26.7692V26.6062V26.4438V26.2821V26.1209V25.9604V25.8005V25.6412V25.4825V25.3244V25.167V25.0102V24.854V24.6984V24.5435V24.3892V24.2355V24.0825V23.9301V23.7783V23.6272V23.4767V23.3268V23.1776V23.029V22.8811V22.7338V22.5871V22.4411V22.2958V22.1511V22.007V21.8636V21.7209V21.5788V21.4374V21.2966V21.1565V21.017V20.8782V20.7401V20.6026V20.4658V20.3296V20.1942V20.0594V19.9252V19.7918V19.659V19.5269V19.3954V19.2647V19.1346V19.0052V18.8765V18.7485V18.6211V18.4945V18.3685V18.2432V18.1186V17.9947V17.8715V17.749V17.6271V17.506V17.3856V17.2659V17.1468V17.0285V16.9109V16.794V16.6778V16.5623V16.4475V16.3334V16.22V16.1073V15.9954V15.8841V15.8448Z"
      stroke="#D9E4EA"
      strokeWidth="15"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M73.9813 41.7549C76.2409 41.1773 78.5748 40.7351 80.9781 40.439L79.0218 24.5591C75.9462 24.938 72.9421 25.5061 70.0187 26.2534C38.5664 34.2933 17.7014 62.5571 16.0993 95.8588C20.6986 89.7896 26.9906 85.0746 34.2736 82.4156C39.7125 62.1357 54.4857 46.7384 73.9813 41.7549ZM38.9205 128C40.0018 130.046 41.1978 132.021 42.5001 133.918C40.5363 135.839 38.5801 138.122 36.9053 140.89C35.508 143.199 34.3671 145.742 33.5384 148.565C28.4506 142.447 24.305 135.518 21.3242 128H38.9205ZM64 170.676V160C64 157.729 64.6055 155.931 65.9378 154.059C73.8195 157.866 82.6605 160 92 160C120.683 160 143.901 142.835 150.245 118.018C150.822 115.759 151.265 113.425 151.561 111.022L167.441 112.978C167.062 116.054 166.494 119.058 165.746 121.981C157.375 154.729 127.079 176 92 176C82.112 176 72.665 174.111 64 170.676Z"
      fill="#D9E4EA"
    />
    <path
      d="M40 184H56V168H40V184ZM48 88C30.32 88 16 102.32 16 120H32C32 111.2 39.2 104 48 104C56.8 104 64 111.2 64 120C64 136 40 134 40 160H56C56 142 80 140 80 120C80 102.32 65.68 88 48 88Z"
      fill="#D9E4EA"
    />
  </svg>
);

export const DatePickerSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 3H6V5H5C3.89543 5 3 5.89543 3 7V9V11V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V11V9V7C21 5.89543 20.1046 5 19 5H18V3H16V5H8V3ZM19 9V7H17H7H5V9H19ZM5 11V17V19H7H17H19V17V11H5Z"
      fill="#6D8991"
    />
  </svg>
);

export const InfoSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.33301 7.99998C1.33301 4.31998 4.31301 1.33331 7.99301 1.33331C11.6797 1.33331 14.6663 4.31998 14.6663 7.99998C14.6663 11.68 11.6797 14.6666 7.99301 14.6666C4.31301 14.6666 1.33301 11.68 1.33301 7.99998ZM2.66634 7.99998C2.66634 10.9466 5.05301 13.3333 7.99967 13.3333C10.9463 13.3333 13.333 10.9466 13.333 7.99998C13.333 5.05331 10.9463 2.66665 7.99967 2.66665C5.05301 2.66665 2.66634 5.05331 2.66634 7.99998Z"
      fill="#6D8991"
    />
    <path
      d="M7.33301 12H8.66634V10.6667H7.33301V12ZM7.99967 4C6.52634 4 5.33301 5.19333 5.33301 6.66667H6.66634C6.66634 5.93333 7.26634 5.33333 7.99967 5.33333C8.73301 5.33333 9.33301 5.93333 9.33301 6.66667C9.33301 8 7.33301 7.83333 7.33301 10H8.66634C8.66634 8.5 10.6663 8.33333 10.6663 6.66667C10.6663 5.19333 9.47301 4 7.99967 4Z"
      fill="#6D8991"
    />
  </svg>
);

export const AddSvgIcon = () => (
  <svg
    // width="18"
    // height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M-4.13263e-07 8L18 8V10L-2.38419e-07 10L-4.13263e-07 8Z"
      fill="#6D8991"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 18L8 1.84559e-07L10 0L10 18H8Z"
      fill="#6D8991"
    />
  </svg>
);

export const AddWhite = () => (
  <svg
    // width="23"
    // height="24"
    // viewBox="0 0 23 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.7982 11L3.20369 11L3.20369 13L19.7982 13L19.7982 11Z"
      fill="white"
    />
    <path
      d="M11.501 3L11.501 21"
      stroke="white"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
  </svg>
);

export const TrashSvg = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 3H8V5H16V3ZM20 9H18V17.024C18 19.1297 16.4059 21 14.2733 21H9.72673C7.59415 21 6 19.1297 6 17.024V9H4V7H20V9ZM8 9H16V17.024C16 18.1932 15.1404 19 14.2733 19H9.72673C8.85961 19 8 18.1932 8 17.024V9Z"
    />
  </svg>
);

export const СrossSvg = () => (
  <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.333374 6.99967C0.333374 3.31301 3.31337 0.333008 7.00004 0.333008C10.6867 0.333008 13.6667 3.31301 13.6667 6.99967C13.6667 10.6863 10.6867 13.6663 7.00004 13.6663C3.31337 13.6663 0.333374 10.6863 0.333374 6.99967ZM9.39337 10.333L10.3334 9.39301L7.94004 6.99967L10.3334 4.60634L9.39337 3.66634L7.00004 6.05967L4.60671 3.66634L3.66671 4.60634L6.06004 6.99967L3.66671 9.39301L4.60671 10.333L7.00004 7.93967L9.39337 10.333Z"
      fill="#56B4A4"
    />
  </svg>
);

export const SortSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.375 5.57143H13.875C14.0408 5.57143 14.1997 5.5037 14.317 5.38314C14.4342 5.26258 14.5 5.09907 14.5 4.92857V3.64286C14.5 3.47236 14.4342 3.30885 14.317 3.18829C14.1997 3.06773 14.0408 3 13.875 3H11.375C11.2093 3 11.0503 3.06773 10.9331 3.18829C10.8159 3.30885 10.75 3.47236 10.75 3.64286V4.92857C10.75 5.09907 10.8159 5.26258 10.9331 5.38314C11.0503 5.5037 11.2093 5.57143 11.375 5.57143ZM11.375 10.7143H16.375C16.5408 10.7143 16.6997 10.6466 16.817 10.526C16.9342 10.4054 17 10.2419 17 10.0714V8.78571C17 8.61522 16.9342 8.45171 16.817 8.33115C16.6997 8.21059 16.5408 8.14286 16.375 8.14286H11.375C11.2093 8.14286 11.0503 8.21059 10.9331 8.33115C10.8159 8.45171 10.75 8.61522 10.75 8.78571V10.0714C10.75 10.2419 10.8159 10.4054 10.9331 10.526C11.0503 10.6466 11.2093 10.7143 11.375 10.7143ZM21.375 18.4286H11.375C11.2093 18.4286 11.0503 18.4963 10.9331 18.6169C10.8159 18.7374 10.75 18.9009 10.75 19.0714V20.3571C10.75 20.5276 10.8159 20.6912 10.9331 20.8117C11.0503 20.9323 11.2093 21 11.375 21H21.375C21.5408 21 21.6997 20.9323 21.8169 20.8117C21.9342 20.6912 22 20.5276 22 20.3571V19.0714C22 18.9009 21.9342 18.7374 21.8169 18.6169C21.6997 18.4963 21.5408 18.4286 21.375 18.4286ZM11.375 15.8571H18.875C19.0408 15.8571 19.1997 15.7894 19.3169 15.6689C19.4342 15.5483 19.5 15.3848 19.5 15.2143V13.9286C19.5 13.7581 19.4342 13.5946 19.3169 13.474C19.1997 13.3534 19.0408 13.2857 18.875 13.2857H11.375C11.2093 13.2857 11.0503 13.3534 10.9331 13.474C10.8159 13.5946 10.75 13.7581 10.75 13.9286V15.2143C10.75 15.3848 10.8159 15.5483 10.9331 15.6689C11.0503 15.7894 11.2093 15.8571 11.375 15.8571ZM8.87502 15.8571H7.00002V3.64286C7.00002 3.47236 6.93417 3.30885 6.81696 3.18829C6.69975 3.06773 6.54078 3 6.37502 3H5.12503C4.95927 3 4.80029 3.06773 4.68308 3.18829C4.56587 3.30885 4.50003 3.47236 4.50003 3.64286V15.8571H2.62503C2.07073 15.8571 1.79026 16.5498 2.18401 16.9544L5.30901 20.8116C5.42621 20.932 5.58512 20.9997 5.75081 20.9997C5.91649 20.9997 6.0754 20.932 6.1926 20.8116L9.3176 16.9544C9.709 16.5506 9.43049 15.8571 8.87502 15.8571Z"
      fill="#6D8991"
    />
  </svg>
);

export const SuccessSvg = () => (
  <svg
    // width="20"
    // height="20"
    // viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 10C0 4.48 4.48 0 10 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10ZM3 10L8 15L17 6L15.59 4.58L8 12.17L4.41 8.59L3 10Z"
      fill="#7ED321"
    />
  </svg>
);

export const InfoToastSvg = () => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM9 15V9H11V15H9ZM9 5V7H11V5H9Z"
      fill="#49ACFB"
    />
  </svg>
);

export const WarningSvg = () => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 19L11 0L0 19H22ZM10 16V14H12V16H10ZM10 12H12V8H10V12Z"
      fill="#FFB405"
    />
  </svg>
);

export const ErrorSvg = () => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.73 0H5.27L0 5.27V12.73L5.27 18H12.73L18 12.73V5.27L12.73 0ZM9 14.3C8.28 14.3 7.7 13.72 7.7 13C7.7 12.28 8.28 11.7 9 11.7C9.72 11.7 10.3 12.28 10.3 13C10.3 13.72 9.72 14.3 9 14.3ZM8 10H10V4H8V10Z"
      fill="#FD5E5E"
    />
  </svg>
);

export const HistorySvg = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 12C4 7.03 8.03 3 13 3C17.97 3 22 7.03 22 12C22 16.97 17.97 21 13 21C10.51 21 8.27 19.99 6.64 18.36L8.06 16.94C9.32 18.21 11.07 19 13 19C16.87 19 20 15.87 20 12C20 8.13 16.87 5 13 5C9.13 5 6 8.13 6 12H9L5 15.99L1 12H4ZM12 13V8H13.5V12.15L17.02 14.24L16.25 15.52L12 13Z"
      fill="currentColor"
    />
  </svg>
);

export const ExcelSvg = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 3C4 2.44772 4.44772 2 5 2H15.2667H15.6966L15.9923 2.31196L18.1257 4.56196L19.7257 6.24946L20 6.53879V6.9375V13H18V8H14V4H6V20H11.5333H15.2667V22H11.5333H5C4.44772 22 4 21.5523 4 21V3ZM18 20V15H20V20H21.5L19 22.5L16.5 20H18ZM9.3122 11C9.37449 11 9.43322 11.029 9.47106 11.0785L11 13.0776L12.5289 11.0785C12.5668 11.029 12.6255 11 12.6878 11L13.7976 11C13.8805 11 13.9274 11.095 13.8771 11.1608L11.7055 14L13.8771 16.8392C13.9274 16.905 13.8805 17 13.7976 17L12.6878 17C12.6255 17 12.5667 16.971 12.5289 16.9215L11 14.9225L9.4711 16.9215C9.43326 16.971 9.37453 17 9.31224 17L8.20238 17C8.11954 17 8.07262 16.905 8.12295 16.8392L10.2945 14L8.12295 11.1608C8.07262 11.095 8.11954 11 8.20238 11L9.3122 11Z"
    />
  </svg>
);

export const WordSvg = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 3C4 2.44772 4.44772 2 5 2H15.2667H15.6966L15.9923 2.31196L18.1257 4.56196L19.7257 6.24946L20 6.53879V6.9375V13H18V8H14V4H6V20H11.5333H15.2667V22H11.5333H5C4.44772 22 4 21.5523 4 21V3ZM18 20V15H20V20H21.5L19 22.5L16.5 20H18ZM9.42047 16.7322C9.48459 16.9427 9.67875 17.0865 9.89876 17.0865H10.1395C10.3629 17.0865 10.5592 16.9383 10.6204 16.7234L11.9349 12.1073C11.9431 12.0782 11.9697 12.0581 12 12.0581C12.0303 12.0581 12.0569 12.0782 12.0651 12.1073L13.3796 16.7234C13.4408 16.9383 13.6371 17.0865 13.8605 17.0865H14.1012C14.3213 17.0865 14.5154 16.9427 14.5795 16.7322L16.2692 11.1868C16.367 10.8655 16.1243 10.5411 15.7885 10.5411C15.5648 10.5411 15.367 10.6896 15.3061 10.9048L14.0036 15.5027C13.9981 15.522 13.9804 15.5354 13.9603 15.5354C13.9401 15.5354 13.9224 15.5219 13.917 15.5024L12.6468 10.9078C12.5869 10.6911 12.3898 10.5411 12.1649 10.5411H11.8512C11.6268 10.5411 11.4299 10.6906 11.3696 10.9067L10.083 15.5195C10.0776 15.539 10.0599 15.5524 10.0397 15.5524C10.0196 15.5524 10.0019 15.539 9.99643 15.5197L8.69371 10.9052C8.6329 10.6898 8.43513 10.5411 8.2113 10.5411C7.87547 10.5411 7.63296 10.8655 7.73084 11.1868L9.42047 16.7322Z"
    />
  </svg>
);

export const PdfSvg = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 3C4 2.44772 4.44772 2 5 2H15.2667H15.6966L15.9923 2.31196L18.1257 4.56196L19.7257 6.24946L20 6.53879V6.9375V13H18V8H14V4H6V20H11.5333H15.2667V22H11.5333H5C4.44772 22 4 21.5523 4 21V3ZM18 20V15H20V20H21.5L19 22.5L16.5 20H18ZM11.5219 10.0451C11.4059 9.98495 11.2684 9.98495 11.1524 10.0451C10.803 10.2265 10.6347 10.5767 10.5606 10.9253C10.4859 11.2769 10.4904 11.6957 10.5419 12.1351C10.5925 12.5666 10.6917 13.0427 10.8266 13.5351C10.715 13.7114 10.5934 13.8868 10.4638 14.0584C10.2493 14.3425 10.0185 14.6086 9.78287 14.8454C9.51611 14.8055 9.25679 14.7831 9.01072 14.7814C8.18159 14.7758 7.3092 15.0158 7.02186 15.8637C6.97611 15.9987 7.00322 16.148 7.09338 16.2577C7.35592 16.5773 7.70827 16.715 8.08205 16.7091C8.43784 16.7035 8.80214 16.5698 9.1429 16.3785C9.44169 16.2108 9.74527 15.986 10.0401 15.7227C10.5206 15.8237 11.0311 15.9825 11.5296 16.183C11.655 16.2335 11.7788 16.2862 11.9002 16.3408C12.1749 16.8958 12.4717 17.4072 12.7721 17.8262C13.0281 18.1835 13.3004 18.4932 13.5788 18.703C13.8484 18.906 14.1969 19.0683 14.5677 18.971C14.6572 18.9475 14.736 18.8937 14.7911 18.8186C15.0369 18.4831 15.0481 18.1017 14.9163 17.7538C14.7926 17.4272 14.5438 17.1233 14.2501 16.8538C13.802 16.4426 13.1814 16.0499 12.5009 15.7202C12.3614 15.4238 12.228 15.1145 12.104 14.7999C11.9526 14.4158 11.8172 14.0282 11.7029 13.6514C11.9911 13.1436 12.2106 12.6185 12.3127 12.1242C12.3953 11.7239 12.4068 11.3155 12.2884 10.9454C12.166 10.5627 11.9124 10.2479 11.5219 10.0451ZM11.5208 11.957C11.4919 12.0967 11.4502 12.2427 11.397 12.3931C11.376 12.2711 11.3587 12.1527 11.3453 12.0387C11.2988 11.6424 11.3033 11.3243 11.3516 11.0971C11.3632 11.0426 11.3763 10.997 11.3903 10.9589C11.4491 11.0294 11.4905 11.1091 11.5187 11.1973C11.5795 11.3875 11.5858 11.6417 11.5208 11.957ZM11.1067 14.555L11.1346 14.5179C11.2033 14.7138 11.2762 14.9093 11.3525 15.1028C11.3741 15.1578 11.3961 15.2127 11.4184 15.2674C11.1838 15.184 10.9461 15.1089 10.7091 15.044C10.8471 14.8863 10.9803 14.7225 11.1067 14.555ZM7.94888 15.8807C8.1184 15.7227 8.40759 15.6179 8.85496 15.6017C8.81983 15.6232 8.78494 15.6437 8.75034 15.6631C8.47187 15.8194 8.24166 15.8883 8.06946 15.891C8.02586 15.8917 7.98587 15.8883 7.94888 15.8807ZM13.4271 17.3461C13.372 17.2692 13.3168 17.1884 13.2615 17.1041C13.4277 17.2219 13.5773 17.3412 13.7065 17.4597C13.9572 17.6898 14.102 17.8909 14.1608 18.0464C14.1721 18.0761 14.18 18.1031 14.1849 18.1278C14.1497 18.1083 14.1089 18.0821 14.062 18.0468C13.8767 17.9072 13.6603 17.6715 13.4271 17.3461Z"
    />
  </svg>
);

export const DeletedItemSvg = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 12C4 7.03 8.03 3 13 3C17.97 3 22 7.03 22 12C22 16.97 17.97 21 13 21C10.51 21 8.27 19.99 6.64 18.36L8.06 16.94C9.32 18.21 11.07 19 13 19C16.87 19 20 15.87 20 12C20 8.13 16.87 5 13 5C9.13 5 6 8.13 6 12H9L5 15.99L1 12H4ZM10.7946 7.1767H14.4394L17.1729 9.91024V15.3773C17.1729 15.8785 16.7629 16.2885 16.2617 16.2885H10.7901C10.2889 16.2885 9.88345 15.8785 9.88345 15.3773V8.08788C9.88345 7.58673 10.2935 7.1767 10.7946 7.1767ZM11.7057 11.5021H15.3504V12.6438H11.7057V11.5021ZM11.7057 13.4321H15.3504V14.4662H11.7057V13.4321ZM15.943 15.1432L11.2599 15.1432L11.2601 8.58143L13.9837 8.58148V10.7052H15.9431L15.943 15.1432Z"
      fill="#6D8991"
    />
  </svg>
);

export const HourGlassSvg = () => (
  <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 1.16699V4.66699H3.50583L3.5 4.67283L5.83333 7.00033L3.5 9.33366L3.50583 9.33949H3.5V12.8337H10.5V9.33949H10.4942L10.5 9.33366L8.16667 7.00033L10.5 4.67283L10.4942 4.66699H10.5V1.16699H3.5ZM9.33333 9.62533V11.667H4.66667V9.62533L7 7.29199L9.33333 9.62533ZM4.66667 2.33366V4.37533L7 6.70866L9.33333 4.37533V2.33366H4.66667Z"
    />
  </svg>
);

export const CheckCircleSvg = () => (
  <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.16663 7.00033C1.16663 3.78033 3.77996 1.16699 6.99996 1.16699C10.22 1.16699 12.8333 3.78033 12.8333 7.00033C12.8333 10.2203 10.22 12.8337 6.99996 12.8337C3.77996 12.8337 1.16663 10.2203 1.16663 7.00033ZM2.91663 7.00033L5.83329 9.91699L11.0833 4.66699L10.2608 3.83866L5.83329 8.26616L3.73913 6.17783L2.91663 7.00033Z"
    />
  </svg>
);

// <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// <path fillRule="evenodd" clipRule="evenodd" d="M5 2C4.44772 2 4 2.44772 4 3V21C4 21.5523 4.44772 22 5 22H11.5333H15.2667V20H11.5333H6V4H14V8H18V13H20V6.9375V6.53879L19.7257 6.24946L18.1257 4.56196L15.9923 2.31196L15.6966 2H15.2667H5ZM18 16V18.0922H16V20.0922H18V22.0337L20 22.0336V20.0922H22.0449V18.0922H20V16H18Z" fill="#6D8991"/>
// <path d="M10.8404 18.0007H12.389V16.4521H10.8404V18.0007ZM11.6147 8.70935C9.90353 8.70935 8.51758 10.0953 8.51758 11.8065H10.0661C10.0661 10.9548 10.763 10.2579 11.6147 10.2579C12.4664 10.2579 13.1632 10.9548 13.1632 11.8065C13.1632 13.355 10.8404 13.1614 10.8404 15.6778H12.389C12.389 13.9357 14.7118 13.7421 14.7118 11.8065C14.7118 10.0953 13.3258 8.70935 11.6147 8.70935Z" fill="#6D8991"/>
// </svg>

export const QuestionMarkDocSvg = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 2C4.44772 2 4 2.44772 4 3V21C4 21.5523 4.44772 22 5 22H11.5333H15.2667V20H11.5333H6V4H14V8H18V13H20V6.9375V6.53879L19.7257 6.24946L18.1257 4.56196L15.9923 2.31196L15.6966 2H15.2667H5ZM18 16V18.0922H16V20.0922H18V22.0337L20 22.0336V20.0922H22.0449V18.0922H20V16H18Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8404 18.0007H12.389V16.4521H10.8404V18.0007ZM11.6147 8.70935C9.90353 8.70935 8.51758 10.0953 8.51758 11.8065H10.0661C10.0661 10.9548 10.763 10.2579 11.6147 10.2579C12.4664 10.2579 13.1632 10.9548 13.1632 11.8065C13.1632 13.355 10.8404 13.1614 10.8404 15.6778H12.389C12.389 13.9357 14.7118 13.7421 14.7118 11.8065C14.7118 10.0953 13.3258 8.70935 11.6147 8.70935Z"
    />
  </svg>
);

export const ReportSvg = () => (
  <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.17583 1.75H4.82417L1.75 4.82417V9.17583L4.82417 12.25H9.17583L12.25 9.17583V4.82417L9.17583 1.75ZM7 10.0917C6.58 10.0917 6.24167 9.75333 6.24167 9.33333C6.24167 8.91333 6.58 8.575 7 8.575C7.42 8.575 7.75833 8.91333 7.75833 9.33333C7.75833 9.75333 7.42 10.0917 7 10.0917ZM6.41667 7.58333H7.58333V4.08333H6.41667V7.58333Z"
    />
  </svg>
);

export const TagSvg = () => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="7.00033" cy="7.50008" r="5.83333" />
  </svg>
);

export const FileCollectionSvg = () => (
  <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9994 2.38354L12.4443 2.6045L22.0443 7.37277L23.8476 8.26849L22.0442 9.16403L12.4442 13.9311L11.9994 14.1519L11.5547 13.9311L1.95466 9.16403L0.151202 8.26849L1.95457 7.37277L11.5546 2.6045L11.9994 2.38354ZM4.64763 8.26826L11.9994 11.9189L19.3512 8.26826L11.9994 4.61666L4.64763 8.26826ZM2.39476 11.2226L2.43594 11.1397L2.43646 11.14L12 15.8895L21.5637 11.1398L21.564 11.1397L21.6051 11.2226L21.6437 11.1447L22.0437 11.3428L23.8518 12.2381L22.0444 13.1348L21.5106 13.3996L21.51 13.3999L21.5099 13.3997L12.4447 17.9016L12 18.1225L11.5552 17.9016L2.48888 13.3991L2.4886 13.3996L2.48823 13.3994L1.955 13.1345L0.149414 12.2375L1.95621 11.3428L2.35621 11.1447L2.39476 11.2226ZM2.43594 15.1103L2.39476 15.1932L2.35621 15.1153L1.95621 15.3134L0.149417 16.208L1.955 17.1051L2.48823 17.37L2.4886 17.3702L2.48888 17.3697L11.5552 21.8722L12 22.0931L12.4447 21.8722L21.5099 17.3702L21.51 17.3705L21.5106 17.3702L22.0444 17.1054L23.8518 16.2087L22.0437 15.3134L21.6437 15.1153L21.6051 15.1932L21.564 15.1103L21.5637 15.1104L12 19.8601L2.43646 15.1106L2.43594 15.1103Z"
      fill="#6D8991"
    />
  </svg>
);

export const BreadCrumbsChevron = () => (
  <svg viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.90405 5.53046L0.174316 9.36379L1.30945 10.5305L6.17432 5.53046L1.30945 0.530457L0.174316 1.69712L3.90405 5.53046Z" />
  </svg>
);

export const MeasurementSvg = () => (
  <svg
    width="21px"
    height="14px"
    viewBox="0 0 21 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>Измерения</title>
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g
      id="GIS"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      fillOpacity="0.65"
      opacity="0.65"
    >
      <g
        id="Гис-фильтр1"
        transform="translate(-952.000000, -24.000000)"
        fill="#000000"
        fillRule="nonzero"
      >
        <g id="Group-16" transform="translate(922.333333, 9.000000)">
          <g id="icons8-width" transform="translate(30.000000, 15.000000)">
            <path
              d="M0,0 L0,14 L2,14 L2,0 L0,0 Z M2,7 L6,10 L6,8 L14,8 L14,10 L18,7 L14,4 L14,6 L6,6 L6,4 L2,7 Z M18,7 L18,14 L20,14 L20,0 L18,0 L18,7 Z M4,0 C3.449219,0 3,0.449219 3,1 C3,1.550781 3.449219,2 4,2 C4.550781,2 5,1.550781 5,1 C5,0.449219 4.550781,0 4,0 Z M8,0 C7.449219,0 7,0.449219 7,1 C7,1.550781 7.449219,2 8,2 C8.550781,2 9,1.550781 9,1 C9,0.449219 8.550781,0 8,0 Z M12,0 C11.449219,0 11,0.449219 11,1 C11,1.550781 11.449219,2 12,2 C12.550781,2 13,1.550781 13,1 C13,0.449219 12.550781,0 12,0 Z M16,0 C15.449219,0 15,0.449219 15,1 C15,1.550781 15.449219,2 16,2 C16.550781,2 17,1.550781 17,1 C17,0.449219 16.550781,0 16,0 Z M4,12 C3.449219,12 3,12.449219 3,13 C3,13.550781 3.449219,14 4,14 C4.550781,14 5,13.550781 5,13 C5,12.449219 4.550781,12 4,12 Z M8,12 C7.449219,12 7,12.449219 7,13 C7,13.550781 7.449219,14 8,14 C8.550781,14 9,13.550781 9,13 C9,12.449219 8.550781,12 8,12 Z M12,12 C11.449219,12 11,12.449219 11,13 C11,13.550781 11.449219,14 12,14 C12.550781,14 13,13.550781 13,13 C13,12.449219 12.550781,12 12,12 Z M16,12 C15.449219,12 15,12.449219 15,13 C15,13.550781 15.449219,14 16,14 C16.550781,14 17,13.550781 17,13 C17,12.449219 16.550781,12 16,12 Z"
              id="Shape"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const HeatmapSvg = () => (
  <svg
    width="25px"
    height="25px"
    viewBox="64 64 896 896"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>Тепловая карта анализа сетей по дефектам</title>
    <defs></defs>
    <g
      id="GIS"
      stroke="none"
      strokeWidth="1"
      fillRule="evenodd"
      fillOpacity="0.65"
      opacity="0.65"
    >
      <path d="M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-790.4-23.9L512 231.9 858.7 832H165.3zm319-474.1l-228 394c-12.3 21.3 3.1 48 27.7 48h455.8c24.7 0 40.1-26.7 27.7-48L539.7 358c-6.2-10.7-17-16-27.7-16-10.8 0-21.6 5.3-27.7 16zm214 386H325.7L512 422l186.3 322zm-214-194.1l-57 98.4C415 669.5 430.4 696 455 696h114c24.6 0 39.9-26.5 27.7-47.7l-57-98.4c-6.1-10.6-16.9-15.9-27.7-15.9s-21.5 5.3-27.7 15.9zm57.1 98.4h-58.7l29.4-50.7 29.3 50.7z"></path>
    </g>
  </svg>
);

export const MapLayersSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.34 3.03L20.5 3C20.78 3 21 3.22 21 3.5V18.62C21 18.85 20.85 19.03 20.64 19.1L15 21L9 18.9L3.66 20.97L3.5 21C3.22 21 3 20.78 3 20.5V5.38C3 5.15 3.15 4.97 3.36 4.9L9 3L15 5.1L20.34 3.03ZM9 16.78L15 18.89V7.22L9 5.11V16.78Z"
      fill="#6D8991"
    />
  </svg>
);

export const MapFullscreenSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 10H5V5H10V7H7V10ZM5 14H7V17H10V19H5V14ZM17 17H14V19H19V14H17V17ZM14 7V5H19V10H17V7H14Z"
      fill="#6D8991"
    />
  </svg>
);
export const MapFullscreenIco = (props) => (
  <Icon component={MapFullscreenSvg} {...props} />
);
export const MapLayersIco = (props) => (
  <Icon component={MapLayersSvg} {...props} />
);

export const MeasurementIco = (props) => (
  <Icon component={MeasurementSvg} {...props} />
);

export const HeatmapIco = (props) => <Icon component={HeatmapSvg} {...props} />;

export const DragSvg = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.31097 4.49535L11.1246 4.49535L11.1121 11.1119C11.1121 11.5998 11.5123 12 12.0001 12C12.4879 12 12.8882 11.5998 12.8882 11.1119L12.8757 4.49535L14.6893 4.49535C15.077 4.49535 15.2772 4.02006 14.9957 3.73863L12.3128 1.05572C12.1377 0.880611 11.8626 0.880611 11.6874 1.05572L9.00453 3.73863C8.72311 4.02006 8.92323 4.49535 9.31097 4.49535ZM4.49549 14.6892L4.49549 12.8755L11.1121 12.8881C11.5999 12.888 12.0001 12.4878 12.0001 12C12.0001 11.5122 11.5999 11.112 11.1121 11.1119L4.49549 11.1245L4.49549 9.31083C4.49549 8.92309 4.02019 8.72297 3.73877 9.00439L1.05586 11.6873C0.880749 11.8624 0.880749 12.1376 1.05586 12.3127L3.73877 14.9956C4.02019 15.277 4.49549 15.0769 4.49549 14.6892ZM14.6893 19.5046L12.8757 19.5047L12.8882 12.8881C12.8882 12.4002 12.4879 12 12.0001 12C11.5123 12 11.1121 12.4002 11.1121 12.8881L11.1246 19.5046L9.31097 19.5046C8.92323 19.5046 8.72311 19.9799 9.00453 20.2614L11.6874 22.9443C11.8626 23.1194 12.1377 23.1194 12.3128 22.9443L14.9957 20.2614C15.2772 19.9799 15.077 19.5046 14.6893 19.5046ZM19.5048 9.31083L19.5048 11.1245L12.5755 11.1119C12.0877 11.1119 11.6874 11.5122 11.6874 12C11.6874 12.4878 12.0877 12.8881 12.5755 12.8881L19.5048 12.8755L19.5048 14.6892C19.5048 15.0769 19.9801 15.277 20.2615 14.9956L22.9444 12.3127C23.1195 12.1376 23.1195 11.8624 22.9444 11.6873L20.2615 9.00439C19.9801 8.72297 19.5048 8.92309 19.5048 9.31083Z" />
  </svg>
);

export const BackSvg = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 11H6.83L10.41 7.41L9 6L3 12L9 18L10.41 16.59L6.83 13H21V11Z" />
  </svg>
);

export const DirectorySvg = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.17071 4C9.58254 2.83481 10.6938 2 12 2C13.3062 2 14.4175 2.83481 14.8293 4H19C19.5523 4 20 4.44772 20 5V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V5C4 4.44772 4.44772 4 5 4H9.17071ZM6 20V6H18V20H6ZM12.75 3.75C12.75 4.16421 12.4142 4.5 12 4.5C11.5858 4.5 11.25 4.16421 11.25 3.75C11.25 3.33579 11.5858 3 12 3C12.4142 3 12.75 3.33579 12.75 3.75ZM8 8V10H16V8H8ZM8 14V12H16V14H8ZM8 18H14V16H8V18Z"
    />
  </svg>
);

export const MenuArrowSvg = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 8L12 15L19 8" />
  </svg>
);

export const LinksSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
  >
    <g id="surface1" opacity="0.65">
      <path d="M 1.835938 1.835938 C 0.675781 3 0.488281 4.050781 1.199219 5.363281 C 2.136719 7.164062 4.273438 7.6875 5.925781 6.5625 C 6.675781 6 6.898438 6.074219 9.5625 7.875 C 13.199219 10.3125 13.238281 11.023438 9.710938 11.175781 C 7.648438 11.25 7.164062 11.175781 6.5625 10.5 C 5.136719 8.925781 2.511719 9.863281 2.511719 12 C 2.511719 14.136719 5.136719 15.074219 6.5625 13.5 C 7.164062 12.824219 7.648438 12.75 9.710938 12.824219 C 13.238281 12.976562 13.199219 13.6875 9.5625 16.125 C 6.898438 17.925781 6.675781 18 5.925781 17.4375 C 4.050781 16.164062 1.425781 17.175781 0.898438 19.386719 C 0.375 21.375 2.625 23.625 4.613281 23.101562 C 5.886719 22.800781 7.125 21.449219 7.125 20.398438 C 7.125 19.800781 7.949219 19.050781 10.351562 17.476562 C 13.386719 15.488281 13.6875 15.375 14.8125 15.75 C 15.488281 15.976562 16.238281 16.050781 16.539062 15.9375 C 17.4375 15.601562 18.824219 18.523438 18.523438 20.101562 C 18.335938 21.148438 18.449219 21.601562 19.164062 22.351562 C 19.613281 22.835938 20.363281 23.25 20.8125 23.25 C 21.824219 23.25 23.25 21.789062 23.25 20.773438 C 23.25 19.914062 21.789062 18.375 20.960938 18.375 C 20.664062 18.375 19.988281 17.664062 19.460938 16.761719 C 18.488281 15.148438 18.488281 15.113281 19.164062 14.289062 C 20.210938 13.011719 20.101562 10.800781 18.9375 9.449219 L 18 8.324219 L 18.789062 6.976562 C 19.238281 6.1875 19.875 5.625 20.25 5.625 C 21 5.625 22.5 3.976562 22.5 3.113281 C 22.5 2.324219 20.773438 0.75 19.875 0.75 C 19.460938 0.75 18.789062 1.085938 18.335938 1.539062 C 17.699219 2.175781 17.585938 2.625 17.773438 3.75 C 18.113281 5.8125 16.988281 7.613281 15.039062 8.175781 C 13.613281 8.625 13.5 8.585938 10.351562 6.523438 C 7.988281 4.988281 7.125 4.199219 7.125 3.601562 C 7.085938 2.664062 6.488281 1.761719 5.363281 1.199219 C 4.050781 0.488281 3 0.675781 1.835938 1.835938 Z M 5.550781 3.824219 C 5.699219 4.574219 4.574219 5.699219 3.824219 5.550781 C 3.523438 5.476562 3.039062 5.0625 2.738281 4.613281 C 2.25 3.898438 2.289062 3.710938 3 3 C 3.710938 2.289062 3.898438 2.25 4.613281 2.738281 C 5.0625 3.039062 5.476562 3.523438 5.550781 3.824219 Z M 20.625 3.1875 C 20.625 3.898438 20.136719 4.125 19.5 3.75 C 19.085938 3.488281 19.085938 3.335938 19.460938 2.851562 C 20.023438 2.210938 20.625 2.363281 20.625 3.1875 Z M 17.699219 10.386719 C 19.238281 11.773438 18.074219 14.25 15.898438 14.25 C 14.625 14.25 13.5 13.199219 13.5 12 C 13.5 11.664062 13.761719 11.023438 14.101562 10.574219 C 14.773438 9.5625 16.6875 9.449219 17.699219 10.386719 Z M 5.4375 12 C 5.4375 12.300781 5.136719 12.601562 4.800781 12.675781 C 4.3125 12.75 4.125 12.5625 4.125 12 C 4.125 11.4375 4.3125 11.25 4.800781 11.324219 C 5.136719 11.398438 5.4375 11.699219 5.4375 12 Z M 5.023438 18.976562 C 5.851562 19.761719 5.773438 20.476562 4.800781 21.148438 C 3.335938 22.199219 1.835938 20.664062 2.851562 19.164062 C 3.523438 18.226562 4.238281 18.148438 5.023438 18.976562 Z M 21.335938 21.226562 C 21 21.636719 20.773438 21.675781 20.398438 21.335938 C 19.988281 21 19.949219 20.773438 20.289062 20.398438 C 20.625 19.988281 20.851562 19.949219 21.226562 20.289062 C 21.636719 20.625 21.675781 20.851562 21.335938 21.226562 Z M 21.335938 21.226562 " />
    </g>
  </svg>
);

export const LinkSvg = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 7H13V9H17C18.65 9 20 10.35 20 12C20 13.65 18.65 15 17 15H13V17H17C19.76 17 22 14.76 22 12C22 9.24 19.76 7 17 7ZM11 15H7C5.35 15 4 13.65 4 12C4 10.35 5.35 9 7 9H11V7H7C4.24 7 2 9.24 2 12C2 14.76 4.24 17 7 17H11V15ZM8 11H16V13H8V11Z" />
  </svg>
);

export const PaperSvg = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM16 12H8V14H16V12ZM16 16H8V18H16V16ZM6 20H18V9H13V4H6V20Z"
    />
  </svg>
);

export const FileCollectionIco = (props) => (
  <Icon component={FileCollectionSvg} {...props} />
);

export const TagIco = (props) => <Icon component={TagSvg} {...props} />;

export const HistoryIco = (props) => <Icon component={HistorySvg} {...props} />;

export const SuccessIco = (props) => <Icon component={SuccessSvg} {...props} />;
export const InfoToastIco = (props) => (
  <Icon component={InfoToastSvg} {...props} />
);

export const WarningIco = (props) => <Icon component={WarningSvg} {...props} />;
export const ErrorIco = (props) => <Icon component={ErrorSvg} {...props} />;

export const AddButtonIco = (props) => (
  <Icon component={AddSvgIcon} {...props} />
);

export const DatePickerIco = (props) => (
  <Icon component={DatePickerSvg} {...props} />
);

export const NoDataIco = (props) => <Icon component={NoDataSvg} {...props} />;

export const ExpandCloseIco = (props) => (
  <Icon component={ExpandCloseSvg} {...props} />
);
export const ExpandOnIco = (props) => (
  <Icon component={ExpandOnSvg} {...props} />
);

export const ButtonDownloadIco = (props) => (
  <Icon component={DownloadSvg} {...props} />
);

export const SearchFieldIco = (props) => (
  <Icon component={SearchInputSvg} {...props} />
);

export const ButtonDeleteIco = (props) => (
  <Icon component={DeleteSvg} {...props} />
);

export const ButtonAddIco = (props) => <Icon component={AddSvg} {...props} />;

export const ButtonEditIco = (props) => <Icon component={EditSvg} {...props} />;

export const PlusIco = (props) => <Icon component={PlusSvg} {...props} />;
export const MinusIco = (props) => <Icon component={MinusSvg} {...props} />;

export const LogoIco = (props) => <Icon component={Logo} {...props} />;

export const VisibleIcon = (props) => (
  <Icon component={VisibleSvg} {...props} />
);
export const InvisibleIcon = (props) => (
  <Icon component={InvisibleSvg} {...props} />
);
export const WrapIco = (props) => <Icon component={WrapSvg} {...props} />;
export const ArrowIco = (props) => <Icon component={ArrowSvg} {...props} />;
export const TeploIco = (props) => <Icon component={TeploSvg} {...props} />;
export const WaterIco = (props) => <Icon component={WaterSvg} {...props} />;
export const ElectroIco = (props) => <Icon component={ElectroSvg} {...props} />;
export const WaterTwoIco = (props) => (
  <Icon component={WaterTwoSvg} {...props} />
);
export const ExpandIco = (props) => <Icon component={ExpandSvg} {...props} />;
export const CollapseIco = (props) => (
  <Icon component={CollapseSvg} {...props} />
);
export const ExportIco = (props) => <Icon component={ExportSvg} {...props} />;
export const FixedIco = (props) => <Icon component={FixedSvg} {...props} />;
export const NotFixedIco = (props) => (
  <Icon component={NotFixedSvg} {...props} />
);
export const CloseIco = (props) => <Icon component={CloseSvg} {...props} />;
export const ExportImgIco = (props) => (
  <Icon component={ExportImgSvg} {...props} />
);
export const TableIco = (props) => <Icon component={TableSvg} {...props} />;
export const OpenCardIco = (props) => (
  <Icon component={OpenCardSvg} {...props} />
);

export const AddIco = (props) => <Icon component={AddSvg_} {...props} />;
export const UploadIco = (props) => <Icon component={UploadSvg} {...props} />;
export const DownloadIco = (props) => (
  <Icon component={DownLoadSvg} {...props} />
);

export const DownloadPdfIco = (props) => (
  <Icon component={DownloadPdfSvg} {...props} />
);

export const ExitIco = (props) => <Icon component={ExitSvg} {...props} />;

export const DropDownIco = (props) => (
  <Icon component={DropDownSvg} {...props} />
);

export const OpenTreeIco = (props) => (
  <Icon component={OpenTreeSvg} {...props} />
);

export const CloseTreeIco = (props) => (
  <Icon component={CloseTreeSvg} {...props} />
);

export const DropDownWithoutSpaceIco = (props) => (
  <Icon component={DropDownWithoutSpaceSvg} {...props} />
);

export const CloseMediumIco = (props) => (
  <Icon component={closeMediumSvg} {...props} />
);

export const SettingsIco = (props) => (
  <Icon component={SettingsFunc} {...props} />
);

export const InfoIco = (props) => <Icon component={InfoSvg} {...props} />;

export const FiltersIco = (props) => <Icon component={FiltersSvg} {...props} />;

export const AddWhiteIco = (props) => <Icon component={AddWhite} {...props} />;

export const TrashIco = (props) => <Icon component={TrashSvg} {...props} />;

export const СrossIco = (props) => <Icon component={СrossSvg} {...props} />;

export const SortIcon = (props) => <Icon component={SortSvg} {...props} />;

export const ExcelIco = (props) => <Icon component={ExcelSvg} {...props} />;

export const WordIco = (props) => <Icon component={WordSvg} {...props} />;

export const PdfIco = (props) => <Icon component={PdfSvg} {...props} />;

export const DeletedItemIco = (props) => (
  <Icon component={DeletedItemSvg} {...props} />
);

export const HourGlassIco = (props) => (
  <Icon component={HourGlassSvg} {...props} />
);

export const CheckCircleIco = (props) => (
  <Icon component={CheckCircleSvg} {...props} />
);

export const ReportIco = (props) => <Icon component={ReportSvg} {...props} />;

export const DragIco = (props) => <Icon component={DragSvg} {...props} />;

export const DeleteFileIco = (props) => (
  <Icon component={DeleteFileSvg} {...props} />
);

export const BreadCrumbsChevronIco = (props) => (
  <Icon component={BreadCrumbsChevron} {...props} />
);

export const BackIco = (props) => <Icon component={BackSvg} {...props} />;

export const DirectoryIco = (props) => (
  <Icon component={DirectorySvg} {...props} />
);

export const MenuArrowIco = (props) => (
  <Icon component={MenuArrowSvg} {...props} />
);

export const LinksIco = (props) => <Icon component={LinksSvg} {...props} />;

export const MapIco = (props) => <Icon component={MapSvgForIcon} {...props} />;
export const MapFieldIco = (props) => (
  <Icon component={MapSvgForField} {...props} />
);

export const LinkIco = (props) => <Icon component={LinkSvg} {...props} />;

export const QuestionMarkDocIco = (props) => (
  <Icon component={QuestionMarkDocSvg} {...props} />
);

export const PaperIco = (props) => <Icon component={PaperSvg} {...props} />;
export const ProfileIco = (props) => <Icon component={UserSvg} {...props} />;
export const AlertIco = (props) => (
  <Icon component={NotificationSvg} {...props} />
);
export const InstructionIco = (props) => (
  <Icon component={ImportSettingsSVG} {...props} />
);
export const ArrowRightIco = (props) => (
  <Icon component={ArrowRightSvg} {...props} />
);
